// Automatically generated with Reach 0.1.7 (d2352c9e)
/* eslint-disable */
export const _version = '0.1.7';
export const _versionHash = '0.1.7 (d2352c9e)';
export const _backendVersion = 6;

export function getExports(s) {
  const stdlib = s.reachStdlib;
  return {
    };
  };
export function _getViews(s, viewlib) {
  const stdlib = s.reachStdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Bool;
  
  return {
    infos: {
      Auction: {
        bids: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v719, v720, v721, v722, v726] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v766, v791, v792] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1289, v1293] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1357, v1362] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        closed: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v719, v720, v721, v722, v726] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v766, v791, v792] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1289, v1293] = svs;
              return (await ((async () => {
                
                
                return true;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1357, v1362] = svs;
              return (await ((async () => {
                
                
                return true;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835] = svs;
              return (await ((async () => {
                
                
                return false;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc3
          },
        closes: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v719, v720, v721, v722, v726] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v766, v791, v792] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1289, v1293] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1357, v1362] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        currentPrice: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v719, v720, v721, v722, v726] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v766, v791, v792] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1289, v1293] = svs;
              return (await ((async () => {
                
                
                return v803;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1357, v1362] = svs;
              return (await ((async () => {
                
                
                return v803;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835] = svs;
              return (await ((async () => {
                
                
                return v803;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        endCTime: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v719, v720, v721, v722, v726] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v766, v791, v792] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1289, v1293] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1357, v1362] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        endSecs: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v719, v720, v721, v722, v726] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v766, v791, v792] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1289, v1293] = svs;
              return (await ((async () => {
                
                
                return v804;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1357, v1362] = svs;
              return (await ((async () => {
                
                
                return v804;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835] = svs;
              return (await ((async () => {
                
                
                return v804;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        highestBidder: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v719, v720, v721, v722, v726] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v766, v791, v792] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1289, v1293] = svs;
              return (await ((async () => {
                
                
                return v805;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1357, v1362] = svs;
              return (await ((async () => {
                
                
                return v805;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835] = svs;
              return (await ((async () => {
                
                
                return v805;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc0
          },
        lastCTime: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v719, v720, v721, v722, v726] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v766, v791, v792] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1289, v1293] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1357, v1362] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        minBid: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v719, v720, v721, v722, v726] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v766, v791, v792] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1289, v1293] = svs;
              return (await ((async () => {
                
                
                return v1277;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1357, v1362] = svs;
              return (await ((async () => {
                
                
                return v1277;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835] = svs;
              return (await ((async () => {
                
                
                return v835;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        owner: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v719, v720, v721, v722, v726] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v766, v791, v792] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1289, v1293] = svs;
              return (await ((async () => {
                
                
                return v753;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1357, v1362] = svs;
              return (await ((async () => {
                
                
                return v753;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835] = svs;
              return (await ((async () => {
                
                
                return v753;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc0
          },
        reservePrice: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v719, v720, v721, v722, v726] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v766, v791, v792] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1289, v1293] = svs;
              return (await ((async () => {
                
                
                return v756;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1357, v1362] = svs;
              return (await ((async () => {
                
                
                return v756;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835] = svs;
              return (await ((async () => {
                
                
                return v756;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        royalties: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v719, v720, v721, v722, v726] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v766, v791, v792] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1289, v1293] = svs;
              return (await ((async () => {
                
                
                return v755;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1357, v1362] = svs;
              return (await ((async () => {
                
                
                return v755;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835] = svs;
              return (await ((async () => {
                
                
                return v755;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        startPrice: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v719, v720, v721, v722, v726] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v766, v791, v792] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1289, v1293] = svs;
              return (await ((async () => {
                
                
                return v757;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1357, v1362] = svs;
              return (await ((async () => {
                
                
                return v757;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835] = svs;
              return (await ((async () => {
                
                
                return v757;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        token: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v719, v720, v721, v722, v726] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v766, v791, v792] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1289, v1293] = svs;
              return (await ((async () => {
                
                
                return v762;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1357, v1362] = svs;
              return (await ((async () => {
                
                
                return v762;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835] = svs;
              return (await ((async () => {
                
                
                return v762;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc2
          },
        tokenP: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v719, v720, v721, v722, v726] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v766, v791, v792] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1289, v1293] = svs;
              return (await ((async () => {
                
                
                return v763;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1357, v1362] = svs;
              return (await ((async () => {
                
                
                return v763;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835] = svs;
              return (await ((async () => {
                
                
                return v763;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc2
          }
        }
      },
    views: {
      1: [ctc0, ctc0, ctc0, ctc0, ctc0],
      2: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0],
      4: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc3, ctc1, ctc1],
      7: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc3, ctc1, ctc1],
      10: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]
      }
    };
  
  };
export function _getMaps(s) {
  const stdlib = s.reachStdlib;
  const ctc0 = stdlib.T_Tuple([]);
  return {
    mapDataTy: ctc0
    };
  };
export async function Auctioneer(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Auctioneer expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Auctioneer expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Object({
    bidIncrementAbs: ctc1,
    bidIncrementRel: ctc1,
    deadline: ctc1,
    deadlineSecs: ctc1,
    deadlineStep: ctc1,
    maxDeadline: ctc1,
    reservePrice: ctc1,
    royaltyAddr: ctc0,
    royaltyCents: ctc1,
    startPrice: ctc1,
    token: ctc2,
    tokenP: ctc2,
    unitAmount: ctc1
    });
  const ctc4 = stdlib.T_Null;
  const ctc5 = stdlib.T_Tuple([ctc4]);
  const ctc6 = stdlib.T_Tuple([ctc1]);
  const ctc7 = stdlib.T_Data({
    Bid_close0: ctc5,
    Bid_getBid0: ctc6,
    Bid_getPurchase0: ctc6,
    Bid_touch0: ctc5
    });
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 4,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v719, v720, v721, v722], secs: v724, time: v723, didSend: v32, from: v718 } = txn1;
  ;
  const v726 = v722;
  const v732 = stdlib.protect(ctc3, await interact.getParams(), {
    at: './token.rsh:95:38:application',
    fs: ['at ./token.rsh:79:18:application call to [unknown function] (defined at: ./token.rsh:79:22:function exp)'],
    msg: 'getParams',
    who: 'Auctioneer'
    });
  const v733 = v732.royaltyAddr;
  const v734 = v732.royaltyCents;
  const v735 = v732.token;
  const v736 = v732.tokenP;
  const v737 = v732.reservePrice;
  const v738 = v732.startPrice;
  const v739 = v732.bidIncrementAbs;
  const v740 = v732.bidIncrementRel;
  const v741 = v732.deadline;
  const v742 = v732.maxDeadline;
  const v743 = v732.unitAmount;
  const v744 = v732.deadlineStep;
  const v745 = v732.deadlineSecs;
  const v746 = stdlib.tokenEq(v735, v736);
  const v747 = v746 ? false : true;
  stdlib.assert(v747, {
    at: './token.rsh:96:11:application',
    fs: ['at ./token.rsh:79:18:application call to [unknown function] (defined at: ./token.rsh:79:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  const v748 = stdlib.ge(v734, stdlib.checkedBigNumberify('./token.rsh:97:28:decimal', stdlib.UInt_max, 0));
  const v749 = stdlib.le(v734, stdlib.checkedBigNumberify('./token.rsh:97:49:decimal', stdlib.UInt_max, 99));
  const v750 = v748 ? v749 : false;
  stdlib.assert(v750, {
    at: './token.rsh:97:11:application',
    fs: ['at ./token.rsh:79:18:application call to [unknown function] (defined at: ./token.rsh:79:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  const v751 = stdlib.ge(v738, stdlib.checkedBigNumberify('./token.rsh:98:26:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v751, {
    at: './token.rsh:98:11:application',
    fs: ['at ./token.rsh:79:18:application call to [unknown function] (defined at: ./token.rsh:79:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  const v752 = stdlib.lt(v738, v737);
  stdlib.assert(v752, {
    at: './token.rsh:99:11:application',
    fs: ['at ./token.rsh:79:18:application call to [unknown function] (defined at: ./token.rsh:79:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  
  const txn2 = await (ctc.sendrecv({
    args: [v719, v720, v721, v722, v726, v733, v734, v737, v738, v739, v740, v741, v742, v735, v736, v743, v744, v745],
    evt_cnt: 13,
    funcNum: 1,
    lct: v723,
    onlyIf: true,
    out_tys: [ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc1],
    pay: [stdlib.checkedBigNumberify('./token.rsh:118:11:decimal', stdlib.UInt_max, 100000), []],
    sim_p: (async (txn2) => {
      const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
      
      const {data: [v754, v755, v756, v757, v758, v759, v760, v761, v762, v763, v764, v765, v766], secs: v768, time: v767, didSend: v83, from: v753 } = txn2;
      
      const v769 = stdlib.tokenEq(v762, v763);
      const v770 = v769 ? false : true;
      stdlib.assert(v770, {
        at: './token.rsh:102:6:dot',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
        kind: 'init',
        tok: v762
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
        kind: 'init',
        tok: v763
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./token.rsh:118:11:decimal', stdlib.UInt_max, 100000),
        kind: 'to',
        tok: undefined
        });
      stdlib.assert(v770, {
        at: './token.rsh:119:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v775 = stdlib.ge(v755, stdlib.checkedBigNumberify('./token.rsh:120:27:decimal', stdlib.UInt_max, 0));
      const v776 = stdlib.le(v755, stdlib.checkedBigNumberify('./token.rsh:120:48:decimal', stdlib.UInt_max, 99));
      const v777 = v775 ? v776 : false;
      stdlib.assert(v777, {
        at: './token.rsh:120:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v778 = stdlib.ge(v757, stdlib.checkedBigNumberify('./token.rsh:121:25:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v778, {
        at: './token.rsh:121:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v779 = stdlib.lt(v757, v756);
      stdlib.assert(v779, {
        at: './token.rsh:122:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v783 = stdlib.sub(stdlib.checkedBigNumberify('./token.rsh:118:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./token.rsh:125:12:decimal', stdlib.UInt_max, 20000));
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./token.rsh:125:12:decimal', stdlib.UInt_max, 20000),
        kind: 'from',
        to: v719,
        tok: undefined
        });
      const v787 = stdlib.sub(v783, stdlib.checkedBigNumberify('./token.rsh:126:12:decimal', stdlib.UInt_max, 30000));
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./token.rsh:126:12:decimal', stdlib.UInt_max, 30000),
        kind: 'from',
        to: v721,
        tok: undefined
        });
      const v791 = stdlib.sub(v787, stdlib.checkedBigNumberify('./token.rsh:127:12:decimal', stdlib.UInt_max, 50000));
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./token.rsh:127:12:decimal', stdlib.UInt_max, 50000),
        kind: 'from',
        to: v722,
        tok: undefined
        });
      const v792 = v753;
      sim_r.isHalt = false;
      
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc1],
    waitIfNotPresent: false
    }));
  const {data: [v754, v755, v756, v757, v758, v759, v760, v761, v762, v763, v764, v765, v766], secs: v768, time: v767, didSend: v83, from: v753 } = txn2;
  const v769 = stdlib.tokenEq(v762, v763);
  const v770 = v769 ? false : true;
  stdlib.assert(v770, {
    at: './token.rsh:102:6:dot',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  ;
  ;
  ;
  stdlib.assert(v770, {
    at: './token.rsh:119:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v775 = stdlib.ge(v755, stdlib.checkedBigNumberify('./token.rsh:120:27:decimal', stdlib.UInt_max, 0));
  const v776 = stdlib.le(v755, stdlib.checkedBigNumberify('./token.rsh:120:48:decimal', stdlib.UInt_max, 99));
  const v777 = v775 ? v776 : false;
  stdlib.assert(v777, {
    at: './token.rsh:120:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v778 = stdlib.ge(v757, stdlib.checkedBigNumberify('./token.rsh:121:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v778, {
    at: './token.rsh:121:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v779 = stdlib.lt(v757, v756);
  stdlib.assert(v779, {
    at: './token.rsh:122:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v783 = stdlib.sub(stdlib.checkedBigNumberify('./token.rsh:118:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./token.rsh:125:12:decimal', stdlib.UInt_max, 20000));
  ;
  const v787 = stdlib.sub(v783, stdlib.checkedBigNumberify('./token.rsh:126:12:decimal', stdlib.UInt_max, 30000));
  ;
  const v791 = stdlib.sub(v787, stdlib.checkedBigNumberify('./token.rsh:127:12:decimal', stdlib.UInt_max, 50000));
  ;
  const v792 = v753;
  const txn3 = await (ctc.recv({
    didSend: false,
    evt_cnt: 0,
    funcNum: 2,
    out_tys: [],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [], secs: v795, time: v794, didSend: v112, from: v793 } = txn3;
  ;
  ;
  const v799 = stdlib.addressEq(v792, v793);
  stdlib.assert(v799, {
    at: './token.rsh:133:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Auctioneer'
    });
  const v802 = 'Start Auction';
  stdlib.protect(ctc4, await interact.log(v802), {
    at: './token.rsh:138:40:application',
    fs: ['at ./token.rsh:138:7:application call to [unknown function] (defined at: ./token.rsh:138:25:function exp)'],
    msg: 'log',
    who: 'Auctioneer'
    });
  
  let v803 = stdlib.checkedBigNumberify('./token.rsh:169:24:decimal', stdlib.UInt_max, 0);
  let v804 = v766;
  let v805 = v753;
  let v806 = true;
  let v807 = v794;
  let v810 = v795;
  let v813 = v791;
  let v814 = stdlib.checkedBigNumberify('./token.rsh:133:15:decimal', stdlib.UInt_max, 1);
  let v815 = stdlib.checkedBigNumberify('./token.rsh:102:6:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    
    return v806;})()) {
    const v830 = stdlib.add(v803, v758);
    const v831 = stdlib.div(v803, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
    const v832 = stdlib.mul(v831, v759);
    const v833 = stdlib.add(v803, v832);
    const v834 = stdlib.gt(v830, v833);
    const v835 = v834 ? v830 : v833;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc7],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v929], secs: v931, time: v930, didSend: v551, from: v928 } = txn4;
    switch (v929[0]) {
      case 'Bid_close0': {
        const v932 = v929[1];
        ;
        ;
        undefined;
        const v954 = null;
        await txn4.getOutput('api', 'v954', ctc4, v954);
        const v961 = stdlib.lt(v810, v804);
        const cv803 = v803;
        const cv804 = v804;
        const cv805 = v805;
        const cv806 = v961;
        const cv807 = v930;
        const cv810 = v931;
        const cv813 = v813;
        const cv814 = v814;
        const cv815 = v815;
        
        v803 = cv803;
        v804 = cv804;
        v805 = cv805;
        v806 = cv806;
        v807 = cv807;
        v810 = cv810;
        v813 = cv813;
        v814 = cv814;
        v815 = cv815;
        
        continue;
        break;
        }
      case 'Bid_getBid0': {
        const v1017 = v929[1];
        const v1018 = v1017[stdlib.checkedBigNumberify('./token.rsh:201:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1036 = stdlib.add(v815, v1018);
        ;
        undefined;
        const v1051 = stdlib.lt(v810, v804);
        const v1058 = stdlib.ge(v1018, v835);
        const v1059 = v1051 ? v1058 : false;
        const v1060 = stdlib.ge(v1018, v757);
        const v1061 = v1059 ? v1060 : false;
        stdlib.assert(v1061, {
          at: './token.rsh:208:18:application',
          fs: ['at ./token.rsh:207:9:application call to [unknown function] (defined at: ./token.rsh:207:9:function exp)'],
          msg: null,
          who: 'Auctioneer'
          });
        const v1065 = stdlib.sub(v1036, v803);
        ;
        const v1066 = null;
        await txn4.getOutput('api', 'v1066', ctc4, v1066);
        const v1072 = stdlib.add(v804, stdlib.checkedBigNumberify('./token.rsh:157:33:decimal', stdlib.UInt_max, 60));
        const cv803 = v1018;
        const cv804 = v1072;
        const cv805 = v928;
        const cv806 = true;
        const cv807 = v930;
        const cv810 = v931;
        const cv813 = v813;
        const cv814 = v814;
        const cv815 = v1065;
        
        v803 = cv803;
        v804 = cv804;
        v805 = cv805;
        v806 = cv806;
        v807 = cv807;
        v810 = cv810;
        v813 = cv813;
        v814 = cv814;
        v815 = cv815;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0': {
        const v1102 = v929[1];
        const v1103 = v1102[stdlib.checkedBigNumberify('./token.rsh:226:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1121 = stdlib.add(v815, v1103);
        ;
        undefined;
        const v1162 = stdlib.ge(v810, v804);
        const v1163 = stdlib.lt(v803, v756);
        const v1164 = v1162 ? v1163 : false;
        const v1165 = stdlib.ge(v1103, v756);
        const v1166 = v1164 ? v1165 : false;
        stdlib.assert(v1166, {
          at: './token.rsh:234:18:application',
          fs: ['at ./token.rsh:233:9:application call to [unknown function] (defined at: ./token.rsh:233:9:function exp)'],
          msg: null,
          who: 'Auctioneer'
          });
        const v1170 = stdlib.sub(v1121, v803);
        ;
        const v1171 = null;
        await txn4.getOutput('api', 'v1171', ctc4, v1171);
        const cv803 = v1103;
        const cv804 = v804;
        const cv805 = v928;
        const cv806 = false;
        const cv807 = v930;
        const cv810 = v931;
        const cv813 = v813;
        const cv814 = v814;
        const cv815 = v1170;
        
        v803 = cv803;
        v804 = cv804;
        v805 = cv805;
        v806 = cv806;
        v807 = cv807;
        v810 = cv810;
        v813 = cv813;
        v814 = cv814;
        v815 = cv815;
        
        continue;
        break;
        }
      case 'Bid_touch0': {
        const v1187 = v929[1];
        ;
        ;
        undefined;
        const v1265 = null;
        await txn4.getOutput('api', 'v1265', ctc4, v1265);
        const cv803 = v803;
        const cv804 = v804;
        const cv805 = v805;
        const cv806 = true;
        const cv807 = v930;
        const cv810 = v931;
        const cv813 = v813;
        const cv814 = v814;
        const cv815 = v815;
        
        v803 = cv803;
        v804 = cv804;
        v805 = cv805;
        v806 = cv806;
        v807 = cv807;
        v810 = cv810;
        v813 = cv813;
        v814 = cv814;
        v815 = cv815;
        
        continue;
        break;
        }
      }
    
    }
  const v1272 = stdlib.add(v803, v758);
  const v1273 = stdlib.div(v803, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
  const v1274 = stdlib.mul(v1273, v759);
  const v1275 = stdlib.add(v803, v1274);
  const v1276 = stdlib.gt(v1272, v1275);
  const v1277 = v1276 ? v1272 : v1275;
  const v1279 = stdlib.div(v815, stdlib.checkedBigNumberify('./token.rsh:272:34:decimal', stdlib.UInt_max, 100));
  const v1280 = stdlib.mul(v755, v1279);
  const v1282 = stdlib.add(v1280, v1279);
  const v1283 = stdlib.sub(v815, v1282);
  const v1284 = stdlib.ge(v803, v756);
  if (v1284) {
    const v1289 = stdlib.sub(v814, v814);
    ;
    const v1293 = stdlib.sub(v815, v1283);
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 4,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1297, time: v1296, didSend: v669, from: v1295 } = txn4;
    ;
    const v1299 = stdlib.addressEq(v726, v1295);
    stdlib.assert(v1299, {
      at: './token.rsh:312:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Auctioneer'
      });
    if (v1284) {
      const v1303 = stdlib.sub(v1293, v1280);
      ;
      const v1307 = stdlib.sub(v1303, v1279);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  else {
    const v1352 = stdlib.add(v1283, v1280);
    const v1353 = stdlib.add(v1352, v1279);
    const v1357 = stdlib.sub(v815, v1353);
    ;
    const v1362 = stdlib.sub(v814, v814);
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 5,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1366, time: v1365, didSend: v669, from: v1364 } = txn4;
    ;
    const v1368 = stdlib.addressEq(v726, v1364);
    stdlib.assert(v1368, {
      at: './token.rsh:312:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Auctioneer'
      });
    if (v1284) {
      const v1372 = stdlib.sub(v1357, v1280);
      ;
      const v1376 = stdlib.sub(v1372, v1279);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  
  
  
  
  
  };
export async function Bid_close(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_close expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_close expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_close0: ctc4,
    Bid_getBid0: ctc5,
    Bid_getPurchase0: ctc5,
    Bid_touch0: ctc4
    });
  
  
  const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10), [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]);
  const v878 = stdlib.protect(ctc4, await interact.in(), {
    at: './token.rsh:1:23:application',
    fs: ['at ./token.rsh:251:11:application call to [unknown function] (defined at: ./token.rsh:251:11:function exp)', 'at ./token.rsh:166:19:application call to "runBid_close0" (defined at: ./token.rsh:251:11:function exp)', 'at ./token.rsh:166:19:application call to [unknown function] (defined at: ./token.rsh:166:19:function exp)'],
    msg: 'in',
    who: 'Bid_close'
    });
  
  const v884 = ['Bid_close0', v878];
  
  const txn1 = await (ctc.sendrecv({
    args: [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835, v884],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./token.rsh:252:18:decimal', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./token.rsh:252:22:decimal', stdlib.UInt_max, 0), v763]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
      
      const {data: [v929], secs: v931, time: v930, didSend: v551, from: v928 } = txn1;
      
      switch (v929[0]) {
        case 'Bid_close0': {
          const v932 = v929[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./token.rsh:252:18:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./token.rsh:252:22:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: v763
            });
          undefined;
          const v954 = null;
          const v955 = await txn1.getOutput('api', 'v954', ctc3, v954);
          
          const v961 = stdlib.lt(v810, v804);
          const v7291 = v803;
          const v7292 = v804;
          const v7293 = v805;
          const v7296 = v931;
          const v7297 = v813;
          const v7298 = v814;
          const v7299 = v815;
          if (v961) {
            const v7300 = stdlib.add(v803, v758);
            const v7301 = stdlib.div(v803, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
            const v7302 = stdlib.mul(v7301, v759);
            const v7303 = stdlib.add(v803, v7302);
            const v7304 = stdlib.gt(v7300, v7303);
            const v7305 = v7304 ? v7300 : v7303;
            sim_r.isHalt = false;
            }
          else {
            const v7306 = stdlib.add(v803, v758);
            const v7307 = stdlib.div(v803, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
            const v7308 = stdlib.mul(v7307, v759);
            const v7309 = stdlib.add(v803, v7308);
            const v7310 = stdlib.gt(v7306, v7309);
            const v7311 = v7310 ? v7306 : v7309;
            const v7312 = stdlib.div(v815, stdlib.checkedBigNumberify('./token.rsh:272:34:decimal', stdlib.UInt_max, 100));
            const v7313 = stdlib.mul(v755, v7312);
            const v7314 = stdlib.add(v7313, v7312);
            const v7315 = stdlib.sub(v815, v7314);
            const v7316 = stdlib.ge(v803, v756);
            if (v7316) {
              const v7317 = stdlib.sub(v814, v814);
              sim_r.txns.push({
                amt: v814,
                kind: 'from',
                to: v805,
                tok: v762
                });
              const v7318 = stdlib.sub(v815, v7315);
              sim_r.txns.push({
                amt: v7315,
                kind: 'from',
                to: v753,
                tok: v763
                });
              sim_r.isHalt = false;
              }
            else {
              const v7326 = stdlib.add(v7315, v7313);
              const v7327 = stdlib.add(v7326, v7312);
              const v7328 = stdlib.sub(v815, v7327);
              sim_r.txns.push({
                amt: v7327,
                kind: 'from',
                to: v805,
                tok: v763
                });
              const v7329 = stdlib.sub(v814, v814);
              sim_r.txns.push({
                amt: v814,
                kind: 'from',
                to: v753,
                tok: v762
                });
              sim_r.isHalt = false;
              }}
          break;
          }
        case 'Bid_getBid0': {
          const v1017 = v929[1];
          
          break;
          }
        case 'Bid_getPurchase0': {
          const v1102 = v929[1];
          
          break;
          }
        case 'Bid_touch0': {
          const v1187 = v929[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v929], secs: v931, time: v930, didSend: v551, from: v928 } = txn1;
  switch (v929[0]) {
    case 'Bid_close0': {
      const v932 = v929[1];
      ;
      ;
      undefined;
      const v954 = null;
      const v955 = await txn1.getOutput('api', 'v954', ctc3, v954);
      if (v551) {
        stdlib.protect(ctc3, await interact.out(v932, v955), {
          at: './token.rsh:251:12:application',
          fs: ['at ./token.rsh:251:12:application call to [unknown function] (defined at: ./token.rsh:251:12:function exp)', 'at ./token.rsh:254:12:application call to "k" (defined at: ./token.rsh:253:9:function exp)', 'at ./token.rsh:253:9:application call to [unknown function] (defined at: ./token.rsh:253:9:function exp)'],
          msg: 'out',
          who: 'Bid_close'
          });
        }
      else {
        }
      
      const v961 = stdlib.lt(v810, v804);
      const v7291 = v803;
      const v7292 = v804;
      const v7293 = v805;
      const v7296 = v931;
      const v7297 = v813;
      const v7298 = v814;
      const v7299 = v815;
      if (v961) {
        const v7300 = stdlib.add(v803, v758);
        const v7301 = stdlib.div(v803, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
        const v7302 = stdlib.mul(v7301, v759);
        const v7303 = stdlib.add(v803, v7302);
        const v7304 = stdlib.gt(v7300, v7303);
        const v7305 = v7304 ? v7300 : v7303;
        return;
        }
      else {
        const v7306 = stdlib.add(v803, v758);
        const v7307 = stdlib.div(v803, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
        const v7308 = stdlib.mul(v7307, v759);
        const v7309 = stdlib.add(v803, v7308);
        const v7310 = stdlib.gt(v7306, v7309);
        const v7311 = v7310 ? v7306 : v7309;
        const v7312 = stdlib.div(v815, stdlib.checkedBigNumberify('./token.rsh:272:34:decimal', stdlib.UInt_max, 100));
        const v7313 = stdlib.mul(v755, v7312);
        const v7314 = stdlib.add(v7313, v7312);
        const v7315 = stdlib.sub(v815, v7314);
        const v7316 = stdlib.ge(v803, v756);
        if (v7316) {
          const v7317 = stdlib.sub(v814, v814);
          ;
          const v7318 = stdlib.sub(v815, v7315);
          ;
          return;
          }
        else {
          const v7326 = stdlib.add(v7315, v7313);
          const v7327 = stdlib.add(v7326, v7312);
          const v7328 = stdlib.sub(v815, v7327);
          ;
          const v7329 = stdlib.sub(v814, v814);
          ;
          return;
          }}
      break;
      }
    case 'Bid_getBid0': {
      const v1017 = v929[1];
      return;
      break;
      }
    case 'Bid_getPurchase0': {
      const v1102 = v929[1];
      return;
      break;
      }
    case 'Bid_touch0': {
      const v1187 = v929[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_getBid(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_getBid expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_getBid expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Tuple([ctc1]);
  const ctc4 = stdlib.T_Null;
  const ctc5 = stdlib.T_Tuple([ctc4]);
  const ctc6 = stdlib.T_Data({
    Bid_close0: ctc5,
    Bid_getBid0: ctc3,
    Bid_getPurchase0: ctc3,
    Bid_touch0: ctc5
    });
  
  
  const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10), [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]);
  const v846 = stdlib.protect(ctc3, await interact.in(), {
    at: './token.rsh:1:23:application',
    fs: ['at ./token.rsh:202:9:application call to [unknown function] (defined at: ./token.rsh:202:9:function exp)', 'at ./token.rsh:166:19:application call to "runBid_getBid0" (defined at: ./token.rsh:201:11:function exp)', 'at ./token.rsh:166:19:application call to [unknown function] (defined at: ./token.rsh:166:19:function exp)'],
    msg: 'in',
    who: 'Bid_getBid'
    });
  const v847 = v846[stdlib.checkedBigNumberify('./token.rsh:201:11:spread', stdlib.UInt_max, 0)];
  const v849 = stdlib.lt(v810, v804);
  const v856 = stdlib.ge(v847, v835);
  const v857 = v849 ? v856 : false;
  const v858 = stdlib.ge(v847, v757);
  const v859 = v857 ? v858 : false;
  stdlib.assert(v859, {
    at: './token.rsh:202:25:application',
    fs: ['at ./token.rsh:202:9:application call to [unknown function] (defined at: ./token.rsh:202:16:function exp)', 'at ./token.rsh:202:9:application call to [unknown function] (defined at: ./token.rsh:202:9:function exp)', 'at ./token.rsh:166:19:application call to "runBid_getBid0" (defined at: ./token.rsh:201:11:function exp)', 'at ./token.rsh:166:19:application call to [unknown function] (defined at: ./token.rsh:166:19:function exp)'],
    msg: null,
    who: 'Bid_getBid'
    });
  
  const v895 = ['Bid_getBid0', v846];
  
  const txn1 = await (ctc.sendrecv({
    args: [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835, v895],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./token.rsh:206:20:decimal', stdlib.UInt_max, 0), [[v847, v763]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
      
      const {data: [v929], secs: v931, time: v930, didSend: v551, from: v928 } = txn1;
      
      switch (v929[0]) {
        case 'Bid_close0': {
          const v932 = v929[1];
          
          break;
          }
        case 'Bid_getBid0': {
          const v1017 = v929[1];
          const v1018 = v1017[stdlib.checkedBigNumberify('./token.rsh:201:11:spread', stdlib.UInt_max, 0)];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./token.rsh:206:20:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          const v1036 = stdlib.add(v815, v1018);
          sim_r.txns.push({
            amt: v1018,
            kind: 'to',
            tok: v763
            });
          undefined;
          const v1058 = stdlib.ge(v1018, v835);
          const v1059 = v849 ? v1058 : false;
          const v1060 = stdlib.ge(v1018, v757);
          const v1061 = v1059 ? v1060 : false;
          stdlib.assert(v1061, {
            at: './token.rsh:208:18:application',
            fs: ['at ./token.rsh:207:9:application call to [unknown function] (defined at: ./token.rsh:207:9:function exp)'],
            msg: null,
            who: 'Bid_getBid'
            });
          const v1065 = stdlib.sub(v1036, v803);
          sim_r.txns.push({
            amt: v803,
            kind: 'from',
            to: v805,
            tok: v763
            });
          const v1066 = null;
          const v1067 = await txn1.getOutput('api', 'v1066', ctc4, v1066);
          
          const v1072 = stdlib.add(v804, stdlib.checkedBigNumberify('./token.rsh:157:33:decimal', stdlib.UInt_max, 60));
          const v7521 = v1018;
          const v7522 = v1072;
          const v7523 = v928;
          const v7526 = v931;
          const v7527 = v813;
          const v7528 = v814;
          const v7529 = v1065;
          const v7530 = stdlib.add(v1018, v758);
          const v7531 = stdlib.div(v1018, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
          const v7532 = stdlib.mul(v7531, v759);
          const v7533 = stdlib.add(v1018, v7532);
          const v7534 = stdlib.gt(v7530, v7533);
          const v7535 = v7534 ? v7530 : v7533;
          sim_r.isHalt = false;
          
          break;
          }
        case 'Bid_getPurchase0': {
          const v1102 = v929[1];
          
          break;
          }
        case 'Bid_touch0': {
          const v1187 = v929[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v929], secs: v931, time: v930, didSend: v551, from: v928 } = txn1;
  switch (v929[0]) {
    case 'Bid_close0': {
      const v932 = v929[1];
      return;
      break;
      }
    case 'Bid_getBid0': {
      const v1017 = v929[1];
      const v1018 = v1017[stdlib.checkedBigNumberify('./token.rsh:201:11:spread', stdlib.UInt_max, 0)];
      ;
      const v1036 = stdlib.add(v815, v1018);
      ;
      undefined;
      const v1058 = stdlib.ge(v1018, v835);
      const v1059 = v849 ? v1058 : false;
      const v1060 = stdlib.ge(v1018, v757);
      const v1061 = v1059 ? v1060 : false;
      stdlib.assert(v1061, {
        at: './token.rsh:208:18:application',
        fs: ['at ./token.rsh:207:9:application call to [unknown function] (defined at: ./token.rsh:207:9:function exp)'],
        msg: null,
        who: 'Bid_getBid'
        });
      const v1065 = stdlib.sub(v1036, v803);
      ;
      const v1066 = null;
      const v1067 = await txn1.getOutput('api', 'v1066', ctc4, v1066);
      if (v551) {
        stdlib.protect(ctc4, await interact.out(v1017, v1067), {
          at: './token.rsh:201:12:application',
          fs: ['at ./token.rsh:201:12:application call to [unknown function] (defined at: ./token.rsh:201:12:function exp)', 'at ./token.rsh:213:12:application call to "k" (defined at: ./token.rsh:207:9:function exp)', 'at ./token.rsh:207:9:application call to [unknown function] (defined at: ./token.rsh:207:9:function exp)'],
          msg: 'out',
          who: 'Bid_getBid'
          });
        }
      else {
        }
      
      const v1072 = stdlib.add(v804, stdlib.checkedBigNumberify('./token.rsh:157:33:decimal', stdlib.UInt_max, 60));
      const v7521 = v1018;
      const v7522 = v1072;
      const v7523 = v928;
      const v7526 = v931;
      const v7527 = v813;
      const v7528 = v814;
      const v7529 = v1065;
      const v7530 = stdlib.add(v1018, v758);
      const v7531 = stdlib.div(v1018, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
      const v7532 = stdlib.mul(v7531, v759);
      const v7533 = stdlib.add(v1018, v7532);
      const v7534 = stdlib.gt(v7530, v7533);
      const v7535 = v7534 ? v7530 : v7533;
      return;
      
      break;
      }
    case 'Bid_getPurchase0': {
      const v1102 = v929[1];
      return;
      break;
      }
    case 'Bid_touch0': {
      const v1187 = v929[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_getPurchase(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_getPurchase expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_getPurchase expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Tuple([ctc1]);
  const ctc4 = stdlib.T_Null;
  const ctc5 = stdlib.T_Tuple([ctc4]);
  const ctc6 = stdlib.T_Data({
    Bid_close0: ctc5,
    Bid_getBid0: ctc3,
    Bid_getPurchase0: ctc3,
    Bid_touch0: ctc5
    });
  
  
  const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10), [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]);
  const v865 = stdlib.protect(ctc3, await interact.in(), {
    at: './token.rsh:1:23:application',
    fs: ['at ./token.rsh:227:9:application call to [unknown function] (defined at: ./token.rsh:227:9:function exp)', 'at ./token.rsh:166:19:application call to "runBid_getPurchase0" (defined at: ./token.rsh:226:11:function exp)', 'at ./token.rsh:166:19:application call to [unknown function] (defined at: ./token.rsh:166:19:function exp)'],
    msg: 'in',
    who: 'Bid_getPurchase'
    });
  const v866 = v865[stdlib.checkedBigNumberify('./token.rsh:226:11:spread', stdlib.UInt_max, 0)];
  const v868 = stdlib.ge(v810, v804);
  const v869 = stdlib.lt(v803, v756);
  const v870 = v868 ? v869 : false;
  const v871 = stdlib.ge(v866, v756);
  const v872 = v870 ? v871 : false;
  stdlib.assert(v872, {
    at: './token.rsh:227:25:application',
    fs: ['at ./token.rsh:227:9:application call to [unknown function] (defined at: ./token.rsh:227:16:function exp)', 'at ./token.rsh:227:9:application call to [unknown function] (defined at: ./token.rsh:227:9:function exp)', 'at ./token.rsh:166:19:application call to "runBid_getPurchase0" (defined at: ./token.rsh:226:11:function exp)', 'at ./token.rsh:166:19:application call to [unknown function] (defined at: ./token.rsh:166:19:function exp)'],
    msg: null,
    who: 'Bid_getPurchase'
    });
  
  const v906 = ['Bid_getPurchase0', v865];
  
  const txn1 = await (ctc.sendrecv({
    args: [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835, v906],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./token.rsh:232:20:decimal', stdlib.UInt_max, 0), [[v866, v763]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
      
      const {data: [v929], secs: v931, time: v930, didSend: v551, from: v928 } = txn1;
      
      switch (v929[0]) {
        case 'Bid_close0': {
          const v932 = v929[1];
          
          break;
          }
        case 'Bid_getBid0': {
          const v1017 = v929[1];
          
          break;
          }
        case 'Bid_getPurchase0': {
          const v1102 = v929[1];
          const v1103 = v1102[stdlib.checkedBigNumberify('./token.rsh:226:11:spread', stdlib.UInt_max, 0)];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./token.rsh:232:20:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          const v1121 = stdlib.add(v815, v1103);
          sim_r.txns.push({
            amt: v1103,
            kind: 'to',
            tok: v763
            });
          undefined;
          const v1165 = stdlib.ge(v1103, v756);
          const v1166 = v870 ? v1165 : false;
          stdlib.assert(v1166, {
            at: './token.rsh:234:18:application',
            fs: ['at ./token.rsh:233:9:application call to [unknown function] (defined at: ./token.rsh:233:9:function exp)'],
            msg: null,
            who: 'Bid_getPurchase'
            });
          const v1170 = stdlib.sub(v1121, v803);
          sim_r.txns.push({
            amt: v803,
            kind: 'from',
            to: v805,
            tok: v763
            });
          const v1171 = null;
          const v1172 = await txn1.getOutput('api', 'v1171', ctc4, v1171);
          
          const v7751 = v1103;
          const v7752 = v804;
          const v7753 = v928;
          const v7757 = v813;
          const v7766 = stdlib.add(v1103, v758);
          const v7767 = stdlib.div(v1103, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
          const v7768 = stdlib.mul(v7767, v759);
          const v7769 = stdlib.add(v1103, v7768);
          const v7770 = stdlib.gt(v7766, v7769);
          const v7771 = v7770 ? v7766 : v7769;
          const v7772 = stdlib.div(v1170, stdlib.checkedBigNumberify('./token.rsh:272:34:decimal', stdlib.UInt_max, 100));
          const v7773 = stdlib.mul(v755, v7772);
          const v7774 = stdlib.add(v7773, v7772);
          const v7775 = stdlib.sub(v1170, v7774);
          if (v1165) {
            const v7777 = stdlib.sub(v814, v814);
            sim_r.txns.push({
              amt: v814,
              kind: 'from',
              to: v928,
              tok: v762
              });
            const v7778 = stdlib.sub(v1170, v7775);
            sim_r.txns.push({
              amt: v7775,
              kind: 'from',
              to: v753,
              tok: v763
              });
            sim_r.isHalt = false;
            }
          else {
            const v7786 = stdlib.add(v7775, v7773);
            const v7787 = stdlib.add(v7786, v7772);
            const v7788 = stdlib.sub(v1170, v7787);
            sim_r.txns.push({
              amt: v7787,
              kind: 'from',
              to: v928,
              tok: v763
              });
            const v7789 = stdlib.sub(v814, v814);
            sim_r.txns.push({
              amt: v814,
              kind: 'from',
              to: v753,
              tok: v762
              });
            sim_r.isHalt = false;
            }
          break;
          }
        case 'Bid_touch0': {
          const v1187 = v929[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v929], secs: v931, time: v930, didSend: v551, from: v928 } = txn1;
  switch (v929[0]) {
    case 'Bid_close0': {
      const v932 = v929[1];
      return;
      break;
      }
    case 'Bid_getBid0': {
      const v1017 = v929[1];
      return;
      break;
      }
    case 'Bid_getPurchase0': {
      const v1102 = v929[1];
      const v1103 = v1102[stdlib.checkedBigNumberify('./token.rsh:226:11:spread', stdlib.UInt_max, 0)];
      ;
      const v1121 = stdlib.add(v815, v1103);
      ;
      undefined;
      const v1165 = stdlib.ge(v1103, v756);
      const v1166 = v870 ? v1165 : false;
      stdlib.assert(v1166, {
        at: './token.rsh:234:18:application',
        fs: ['at ./token.rsh:233:9:application call to [unknown function] (defined at: ./token.rsh:233:9:function exp)'],
        msg: null,
        who: 'Bid_getPurchase'
        });
      const v1170 = stdlib.sub(v1121, v803);
      ;
      const v1171 = null;
      const v1172 = await txn1.getOutput('api', 'v1171', ctc4, v1171);
      if (v551) {
        stdlib.protect(ctc4, await interact.out(v1102, v1172), {
          at: './token.rsh:226:12:application',
          fs: ['at ./token.rsh:226:12:application call to [unknown function] (defined at: ./token.rsh:226:12:function exp)', 'at ./token.rsh:240:12:application call to "k" (defined at: ./token.rsh:233:9:function exp)', 'at ./token.rsh:233:9:application call to [unknown function] (defined at: ./token.rsh:233:9:function exp)'],
          msg: 'out',
          who: 'Bid_getPurchase'
          });
        }
      else {
        }
      
      const v7751 = v1103;
      const v7752 = v804;
      const v7753 = v928;
      const v7757 = v813;
      const v7766 = stdlib.add(v1103, v758);
      const v7767 = stdlib.div(v1103, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
      const v7768 = stdlib.mul(v7767, v759);
      const v7769 = stdlib.add(v1103, v7768);
      const v7770 = stdlib.gt(v7766, v7769);
      const v7771 = v7770 ? v7766 : v7769;
      const v7772 = stdlib.div(v1170, stdlib.checkedBigNumberify('./token.rsh:272:34:decimal', stdlib.UInt_max, 100));
      const v7773 = stdlib.mul(v755, v7772);
      const v7774 = stdlib.add(v7773, v7772);
      const v7775 = stdlib.sub(v1170, v7774);
      if (v1165) {
        const v7777 = stdlib.sub(v814, v814);
        ;
        const v7778 = stdlib.sub(v1170, v7775);
        ;
        return;
        }
      else {
        const v7786 = stdlib.add(v7775, v7773);
        const v7787 = stdlib.add(v7786, v7772);
        const v7788 = stdlib.sub(v1170, v7787);
        ;
        const v7789 = stdlib.sub(v814, v814);
        ;
        return;
        }
      break;
      }
    case 'Bid_touch0': {
      const v1187 = v929[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_touch(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_touch expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_touch expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_close0: ctc4,
    Bid_getBid0: ctc5,
    Bid_getPurchase0: ctc5,
    Bid_touch0: ctc4
    });
  
  
  const [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10), [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]);
  const v838 = stdlib.protect(ctc4, await interact.in(), {
    at: './token.rsh:1:23:application',
    fs: ['at ./token.rsh:185:11:application call to [unknown function] (defined at: ./token.rsh:185:11:function exp)', 'at ./token.rsh:166:19:application call to "runBid_touch0" (defined at: ./token.rsh:185:11:function exp)', 'at ./token.rsh:166:19:application call to [unknown function] (defined at: ./token.rsh:166:19:function exp)'],
    msg: 'in',
    who: 'Bid_touch'
    });
  
  const v917 = ['Bid_touch0', v838];
  
  const txn1 = await (ctc.sendrecv({
    args: [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v803, v804, v805, v810, v813, v814, v815, v835, v917],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./token.rsh:186:18:decimal', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./token.rsh:186:22:decimal', stdlib.UInt_max, 0), v763]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
      
      const {data: [v929], secs: v931, time: v930, didSend: v551, from: v928 } = txn1;
      
      switch (v929[0]) {
        case 'Bid_close0': {
          const v932 = v929[1];
          
          break;
          }
        case 'Bid_getBid0': {
          const v1017 = v929[1];
          
          break;
          }
        case 'Bid_getPurchase0': {
          const v1102 = v929[1];
          
          break;
          }
        case 'Bid_touch0': {
          const v1187 = v929[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./token.rsh:186:18:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./token.rsh:186:22:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: v763
            });
          undefined;
          const v1265 = null;
          const v1266 = await txn1.getOutput('api', 'v1265', ctc3, v1265);
          
          const v7981 = v803;
          const v7982 = v804;
          const v7983 = v805;
          const v7986 = v931;
          const v7987 = v813;
          const v7988 = v814;
          const v7989 = v815;
          const v7990 = stdlib.add(v803, v758);
          const v7991 = stdlib.div(v803, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
          const v7992 = stdlib.mul(v7991, v759);
          const v7993 = stdlib.add(v803, v7992);
          const v7994 = stdlib.gt(v7990, v7993);
          const v7995 = v7994 ? v7990 : v7993;
          sim_r.isHalt = false;
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v929], secs: v931, time: v930, didSend: v551, from: v928 } = txn1;
  switch (v929[0]) {
    case 'Bid_close0': {
      const v932 = v929[1];
      return;
      break;
      }
    case 'Bid_getBid0': {
      const v1017 = v929[1];
      return;
      break;
      }
    case 'Bid_getPurchase0': {
      const v1102 = v929[1];
      return;
      break;
      }
    case 'Bid_touch0': {
      const v1187 = v929[1];
      ;
      ;
      undefined;
      const v1265 = null;
      const v1266 = await txn1.getOutput('api', 'v1265', ctc3, v1265);
      if (v551) {
        stdlib.protect(ctc3, await interact.out(v1187, v1266), {
          at: './token.rsh:185:12:application',
          fs: ['at ./token.rsh:185:12:application call to [unknown function] (defined at: ./token.rsh:185:12:function exp)', 'at ./token.rsh:188:12:application call to "k" (defined at: ./token.rsh:187:9:function exp)', 'at ./token.rsh:187:9:application call to [unknown function] (defined at: ./token.rsh:187:9:function exp)'],
          msg: 'out',
          who: 'Bid_touch'
          });
        }
      else {
        }
      
      const v7981 = v803;
      const v7982 = v804;
      const v7983 = v805;
      const v7986 = v931;
      const v7987 = v813;
      const v7988 = v814;
      const v7989 = v815;
      const v7990 = stdlib.add(v803, v758);
      const v7991 = stdlib.div(v803, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
      const v7992 = stdlib.mul(v7991, v759);
      const v7993 = stdlib.add(v803, v7992);
      const v7994 = stdlib.gt(v7990, v7993);
      const v7995 = v7994 ? v7990 : v7993;
      return;
      
      break;
      }
    }
  
  
  };
export async function Constructor(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Constructor expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Constructor expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_Object({
    addr: ctc0,
    addr2: ctc0,
    addr3: ctc0,
    addr4: ctc0
    });
  const ctc2 = stdlib.T_Null;
  const ctc3 = stdlib.T_UInt;
  const ctc4 = stdlib.T_Token;
  const ctc5 = stdlib.T_Tuple([ctc2]);
  const ctc6 = stdlib.T_Tuple([ctc3]);
  const ctc7 = stdlib.T_Data({
    Bid_close0: ctc5,
    Bid_getBid0: ctc6,
    Bid_getPurchase0: ctc6,
    Bid_touch0: ctc5
    });
  
  
  const v713 = stdlib.protect(ctc1, await interact.getParams(), {
    at: './util.rsh:43:38:application',
    fs: ['at ./util.rsh:37:19:application call to [unknown function] (defined at: ./util.rsh:37:23:function exp)', 'at ./token.rsh:74:50:application call to "construct" (defined at: ./util.rsh:36:47:function exp)'],
    msg: 'getParams',
    who: 'Constructor'
    });
  const v714 = v713.addr;
  const v715 = v713.addr2;
  const v716 = v713.addr3;
  const v717 = v713.addr4;
  
  const txn1 = await (ctc.sendrecv({
    args: [v714, v715, v716, v717],
    evt_cnt: 4,
    funcNum: 0,
    lct: stdlib.checkedBigNumberify('./util.rsh:47:6:dot', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    pay: [stdlib.checkedBigNumberify('./util.rsh:decimal', stdlib.UInt_max, 0), []],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
      
      const {data: [v719, v720, v721, v722], secs: v724, time: v723, didSend: v32, from: v718 } = txn1;
      
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./util.rsh:decimal', stdlib.UInt_max, 0),
        kind: 'to',
        tok: undefined
        });
      const v726 = v722;
      sim_r.isHalt = false;
      
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0],
    waitIfNotPresent: false
    }));
  const {data: [v719, v720, v721, v722], secs: v724, time: v723, didSend: v32, from: v718 } = txn1;
  ;
  const v726 = v722;
  stdlib.protect(ctc2, await interact.signal(), {
    at: './util.rsh:55:41:application',
    fs: ['at ./util.rsh:55:19:application call to [unknown function] (defined at: ./util.rsh:55:23:function exp)', 'at ./token.rsh:74:50:application call to "construct" (defined at: ./util.rsh:36:47:function exp)'],
    msg: 'signal',
    who: 'Constructor'
    });
  
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 13,
    funcNum: 1,
    out_tys: [ctc0, ctc3, ctc3, ctc3, ctc3, ctc3, ctc3, ctc3, ctc4, ctc4, ctc3, ctc3, ctc3],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v754, v755, v756, v757, v758, v759, v760, v761, v762, v763, v764, v765, v766], secs: v768, time: v767, didSend: v83, from: v753 } = txn2;
  const v769 = stdlib.tokenEq(v762, v763);
  const v770 = v769 ? false : true;
  stdlib.assert(v770, {
    at: './token.rsh:102:6:dot',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  ;
  ;
  ;
  stdlib.assert(v770, {
    at: './token.rsh:119:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v775 = stdlib.ge(v755, stdlib.checkedBigNumberify('./token.rsh:120:27:decimal', stdlib.UInt_max, 0));
  const v776 = stdlib.le(v755, stdlib.checkedBigNumberify('./token.rsh:120:48:decimal', stdlib.UInt_max, 99));
  const v777 = v775 ? v776 : false;
  stdlib.assert(v777, {
    at: './token.rsh:120:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v778 = stdlib.ge(v757, stdlib.checkedBigNumberify('./token.rsh:121:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v778, {
    at: './token.rsh:121:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v779 = stdlib.lt(v757, v756);
  stdlib.assert(v779, {
    at: './token.rsh:122:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v783 = stdlib.sub(stdlib.checkedBigNumberify('./token.rsh:118:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./token.rsh:125:12:decimal', stdlib.UInt_max, 20000));
  ;
  const v787 = stdlib.sub(v783, stdlib.checkedBigNumberify('./token.rsh:126:12:decimal', stdlib.UInt_max, 30000));
  ;
  const v791 = stdlib.sub(v787, stdlib.checkedBigNumberify('./token.rsh:127:12:decimal', stdlib.UInt_max, 50000));
  ;
  const v792 = v753;
  const txn3 = await (ctc.recv({
    didSend: false,
    evt_cnt: 0,
    funcNum: 2,
    out_tys: [],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [], secs: v795, time: v794, didSend: v112, from: v793 } = txn3;
  ;
  ;
  const v799 = stdlib.addressEq(v792, v793);
  stdlib.assert(v799, {
    at: './token.rsh:133:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Constructor'
    });
  let v803 = stdlib.checkedBigNumberify('./token.rsh:169:24:decimal', stdlib.UInt_max, 0);
  let v804 = v766;
  let v805 = v753;
  let v806 = true;
  let v807 = v794;
  let v810 = v795;
  let v813 = v791;
  let v814 = stdlib.checkedBigNumberify('./token.rsh:133:15:decimal', stdlib.UInt_max, 1);
  let v815 = stdlib.checkedBigNumberify('./token.rsh:102:6:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    
    return v806;})()) {
    const v830 = stdlib.add(v803, v758);
    const v831 = stdlib.div(v803, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
    const v832 = stdlib.mul(v831, v759);
    const v833 = stdlib.add(v803, v832);
    const v834 = stdlib.gt(v830, v833);
    const v835 = v834 ? v830 : v833;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc7],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v929], secs: v931, time: v930, didSend: v551, from: v928 } = txn4;
    switch (v929[0]) {
      case 'Bid_close0': {
        const v932 = v929[1];
        ;
        ;
        undefined;
        const v954 = null;
        await txn4.getOutput('api', 'v954', ctc2, v954);
        const v961 = stdlib.lt(v810, v804);
        const cv803 = v803;
        const cv804 = v804;
        const cv805 = v805;
        const cv806 = v961;
        const cv807 = v930;
        const cv810 = v931;
        const cv813 = v813;
        const cv814 = v814;
        const cv815 = v815;
        
        v803 = cv803;
        v804 = cv804;
        v805 = cv805;
        v806 = cv806;
        v807 = cv807;
        v810 = cv810;
        v813 = cv813;
        v814 = cv814;
        v815 = cv815;
        
        continue;
        break;
        }
      case 'Bid_getBid0': {
        const v1017 = v929[1];
        const v1018 = v1017[stdlib.checkedBigNumberify('./token.rsh:201:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1036 = stdlib.add(v815, v1018);
        ;
        undefined;
        const v1051 = stdlib.lt(v810, v804);
        const v1058 = stdlib.ge(v1018, v835);
        const v1059 = v1051 ? v1058 : false;
        const v1060 = stdlib.ge(v1018, v757);
        const v1061 = v1059 ? v1060 : false;
        stdlib.assert(v1061, {
          at: './token.rsh:208:18:application',
          fs: ['at ./token.rsh:207:9:application call to [unknown function] (defined at: ./token.rsh:207:9:function exp)'],
          msg: null,
          who: 'Constructor'
          });
        const v1065 = stdlib.sub(v1036, v803);
        ;
        const v1066 = null;
        await txn4.getOutput('api', 'v1066', ctc2, v1066);
        const v1072 = stdlib.add(v804, stdlib.checkedBigNumberify('./token.rsh:157:33:decimal', stdlib.UInt_max, 60));
        const cv803 = v1018;
        const cv804 = v1072;
        const cv805 = v928;
        const cv806 = true;
        const cv807 = v930;
        const cv810 = v931;
        const cv813 = v813;
        const cv814 = v814;
        const cv815 = v1065;
        
        v803 = cv803;
        v804 = cv804;
        v805 = cv805;
        v806 = cv806;
        v807 = cv807;
        v810 = cv810;
        v813 = cv813;
        v814 = cv814;
        v815 = cv815;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0': {
        const v1102 = v929[1];
        const v1103 = v1102[stdlib.checkedBigNumberify('./token.rsh:226:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1121 = stdlib.add(v815, v1103);
        ;
        undefined;
        const v1162 = stdlib.ge(v810, v804);
        const v1163 = stdlib.lt(v803, v756);
        const v1164 = v1162 ? v1163 : false;
        const v1165 = stdlib.ge(v1103, v756);
        const v1166 = v1164 ? v1165 : false;
        stdlib.assert(v1166, {
          at: './token.rsh:234:18:application',
          fs: ['at ./token.rsh:233:9:application call to [unknown function] (defined at: ./token.rsh:233:9:function exp)'],
          msg: null,
          who: 'Constructor'
          });
        const v1170 = stdlib.sub(v1121, v803);
        ;
        const v1171 = null;
        await txn4.getOutput('api', 'v1171', ctc2, v1171);
        const cv803 = v1103;
        const cv804 = v804;
        const cv805 = v928;
        const cv806 = false;
        const cv807 = v930;
        const cv810 = v931;
        const cv813 = v813;
        const cv814 = v814;
        const cv815 = v1170;
        
        v803 = cv803;
        v804 = cv804;
        v805 = cv805;
        v806 = cv806;
        v807 = cv807;
        v810 = cv810;
        v813 = cv813;
        v814 = cv814;
        v815 = cv815;
        
        continue;
        break;
        }
      case 'Bid_touch0': {
        const v1187 = v929[1];
        ;
        ;
        undefined;
        const v1265 = null;
        await txn4.getOutput('api', 'v1265', ctc2, v1265);
        const cv803 = v803;
        const cv804 = v804;
        const cv805 = v805;
        const cv806 = true;
        const cv807 = v930;
        const cv810 = v931;
        const cv813 = v813;
        const cv814 = v814;
        const cv815 = v815;
        
        v803 = cv803;
        v804 = cv804;
        v805 = cv805;
        v806 = cv806;
        v807 = cv807;
        v810 = cv810;
        v813 = cv813;
        v814 = cv814;
        v815 = cv815;
        
        continue;
        break;
        }
      }
    
    }
  const v1272 = stdlib.add(v803, v758);
  const v1273 = stdlib.div(v803, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
  const v1274 = stdlib.mul(v1273, v759);
  const v1275 = stdlib.add(v803, v1274);
  const v1276 = stdlib.gt(v1272, v1275);
  const v1277 = v1276 ? v1272 : v1275;
  const v1279 = stdlib.div(v815, stdlib.checkedBigNumberify('./token.rsh:272:34:decimal', stdlib.UInt_max, 100));
  const v1280 = stdlib.mul(v755, v1279);
  const v1282 = stdlib.add(v1280, v1279);
  const v1283 = stdlib.sub(v815, v1282);
  const v1284 = stdlib.ge(v803, v756);
  if (v1284) {
    const v1289 = stdlib.sub(v814, v814);
    ;
    const v1293 = stdlib.sub(v815, v1283);
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 4,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1297, time: v1296, didSend: v669, from: v1295 } = txn4;
    ;
    const v1299 = stdlib.addressEq(v726, v1295);
    stdlib.assert(v1299, {
      at: './token.rsh:312:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Constructor'
      });
    if (v1284) {
      const v1303 = stdlib.sub(v1293, v1280);
      ;
      const v1307 = stdlib.sub(v1303, v1279);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  else {
    const v1352 = stdlib.add(v1283, v1280);
    const v1353 = stdlib.add(v1352, v1279);
    const v1357 = stdlib.sub(v815, v1353);
    ;
    const v1362 = stdlib.sub(v814, v814);
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 5,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1366, time: v1365, didSend: v669, from: v1364 } = txn4;
    ;
    const v1368 = stdlib.addressEq(v726, v1364);
    stdlib.assert(v1368, {
      at: './token.rsh:312:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Constructor'
      });
    if (v1284) {
      const v1372 = stdlib.sub(v1357, v1280);
      ;
      const v1376 = stdlib.sub(v1372, v1279);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  
  
  
  
  
  };
export async function Depositer(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Depositer expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Depositer expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_close0: ctc4,
    Bid_getBid0: ctc5,
    Bid_getPurchase0: ctc5,
    Bid_touch0: ctc4
    });
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 4,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v719, v720, v721, v722], secs: v724, time: v723, didSend: v32, from: v718 } = txn1;
  ;
  const v726 = v722;
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 13,
    funcNum: 1,
    out_tys: [ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc1],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v754, v755, v756, v757, v758, v759, v760, v761, v762, v763, v764, v765, v766], secs: v768, time: v767, didSend: v83, from: v753 } = txn2;
  const v769 = stdlib.tokenEq(v762, v763);
  const v770 = v769 ? false : true;
  stdlib.assert(v770, {
    at: './token.rsh:102:6:dot',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  ;
  ;
  ;
  stdlib.assert(v770, {
    at: './token.rsh:119:10:application',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  const v775 = stdlib.ge(v755, stdlib.checkedBigNumberify('./token.rsh:120:27:decimal', stdlib.UInt_max, 0));
  const v776 = stdlib.le(v755, stdlib.checkedBigNumberify('./token.rsh:120:48:decimal', stdlib.UInt_max, 99));
  const v777 = v775 ? v776 : false;
  stdlib.assert(v777, {
    at: './token.rsh:120:10:application',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  const v778 = stdlib.ge(v757, stdlib.checkedBigNumberify('./token.rsh:121:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v778, {
    at: './token.rsh:121:10:application',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  const v779 = stdlib.lt(v757, v756);
  stdlib.assert(v779, {
    at: './token.rsh:122:10:application',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  const v783 = stdlib.sub(stdlib.checkedBigNumberify('./token.rsh:118:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./token.rsh:125:12:decimal', stdlib.UInt_max, 20000));
  ;
  const v787 = stdlib.sub(v783, stdlib.checkedBigNumberify('./token.rsh:126:12:decimal', stdlib.UInt_max, 30000));
  ;
  const v791 = stdlib.sub(v787, stdlib.checkedBigNumberify('./token.rsh:127:12:decimal', stdlib.UInt_max, 50000));
  ;
  const v792 = ctc.iam(v753);
  const txn3 = await (ctc.sendrecv({
    args: [v720, v726, v753, v754, v755, v756, v757, v758, v759, v762, v763, v766, v791, v792],
    evt_cnt: 0,
    funcNum: 2,
    lct: v767,
    onlyIf: true,
    out_tys: [],
    pay: [stdlib.checkedBigNumberify('./token.rsh:133:11:decimal', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./token.rsh:133:15:decimal', stdlib.UInt_max, 1), v762]]],
    sim_p: (async (txn3) => {
      const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
      
      const {data: [], secs: v795, time: v794, didSend: v112, from: v793 } = txn3;
      
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./token.rsh:133:11:decimal', stdlib.UInt_max, 0),
        kind: 'to',
        tok: undefined
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./token.rsh:133:15:decimal', stdlib.UInt_max, 1),
        kind: 'to',
        tok: v762
        });
      const v799 = stdlib.addressEq(v792, v793);
      stdlib.assert(v799, {
        at: './token.rsh:133:6:dot',
        fs: [],
        msg: 'sender correct',
        who: 'Depositer'
        });
      
      const v803 = stdlib.checkedBigNumberify('./token.rsh:169:24:decimal', stdlib.UInt_max, 0);
      const v804 = v766;
      const v805 = v753;
      const v806 = true;
      const v807 = v794;
      const v810 = v795;
      const v813 = v791;
      const v814 = stdlib.checkedBigNumberify('./token.rsh:133:15:decimal', stdlib.UInt_max, 1);
      const v815 = stdlib.checkedBigNumberify('./token.rsh:102:6:dot', stdlib.UInt_max, 0);
      
      if (await (async () => {
        
        return v806;})()) {
        const v830 = stdlib.add(v803, v758);
        const v831 = stdlib.div(v803, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
        const v832 = stdlib.mul(v831, v759);
        const v833 = stdlib.add(v803, v832);
        const v834 = stdlib.gt(v830, v833);
        const v835 = v834 ? v830 : v833;
        sim_r.isHalt = false;
        }
      else {
        const v1272 = stdlib.add(v803, v758);
        const v1273 = stdlib.div(v803, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
        const v1274 = stdlib.mul(v1273, v759);
        const v1275 = stdlib.add(v803, v1274);
        const v1276 = stdlib.gt(v1272, v1275);
        const v1277 = v1276 ? v1272 : v1275;
        const v1279 = stdlib.div(v815, stdlib.checkedBigNumberify('./token.rsh:272:34:decimal', stdlib.UInt_max, 100));
        const v1280 = stdlib.mul(v755, v1279);
        const v1282 = stdlib.add(v1280, v1279);
        const v1283 = stdlib.sub(v815, v1282);
        const v1284 = stdlib.ge(v803, v756);
        if (v1284) {
          const v1289 = stdlib.sub(v814, v814);
          sim_r.txns.push({
            amt: v814,
            kind: 'from',
            to: v805,
            tok: v762
            });
          const v1293 = stdlib.sub(v815, v1283);
          sim_r.txns.push({
            amt: v1283,
            kind: 'from',
            to: v753,
            tok: v763
            });
          sim_r.isHalt = false;
          }
        else {
          const v1352 = stdlib.add(v1283, v1280);
          const v1353 = stdlib.add(v1352, v1279);
          const v1357 = stdlib.sub(v815, v1353);
          sim_r.txns.push({
            amt: v1353,
            kind: 'from',
            to: v805,
            tok: v763
            });
          const v1362 = stdlib.sub(v814, v814);
          sim_r.txns.push({
            amt: v814,
            kind: 'from',
            to: v753,
            tok: v762
            });
          sim_r.isHalt = false;
          }}
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0],
    waitIfNotPresent: false
    }));
  const {data: [], secs: v795, time: v794, didSend: v112, from: v793 } = txn3;
  ;
  ;
  const v799 = stdlib.addressEq(v792, v793);
  stdlib.assert(v799, {
    at: './token.rsh:133:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Depositer'
    });
  stdlib.protect(ctc3, await interact.signal(), {
    at: './token.rsh:135:39:application',
    fs: ['at ./token.rsh:135:17:application call to [unknown function] (defined at: ./token.rsh:135:21:function exp)'],
    msg: 'signal',
    who: 'Depositer'
    });
  
  let v803 = stdlib.checkedBigNumberify('./token.rsh:169:24:decimal', stdlib.UInt_max, 0);
  let v804 = v766;
  let v805 = v753;
  let v806 = true;
  let v807 = v794;
  let v810 = v795;
  let v813 = v791;
  let v814 = stdlib.checkedBigNumberify('./token.rsh:133:15:decimal', stdlib.UInt_max, 1);
  let v815 = stdlib.checkedBigNumberify('./token.rsh:102:6:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    
    return v806;})()) {
    const v830 = stdlib.add(v803, v758);
    const v831 = stdlib.div(v803, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
    const v832 = stdlib.mul(v831, v759);
    const v833 = stdlib.add(v803, v832);
    const v834 = stdlib.gt(v830, v833);
    const v835 = v834 ? v830 : v833;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc6],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v929], secs: v931, time: v930, didSend: v551, from: v928 } = txn4;
    switch (v929[0]) {
      case 'Bid_close0': {
        const v932 = v929[1];
        ;
        ;
        undefined;
        const v954 = null;
        await txn4.getOutput('api', 'v954', ctc3, v954);
        const v961 = stdlib.lt(v810, v804);
        const cv803 = v803;
        const cv804 = v804;
        const cv805 = v805;
        const cv806 = v961;
        const cv807 = v930;
        const cv810 = v931;
        const cv813 = v813;
        const cv814 = v814;
        const cv815 = v815;
        
        v803 = cv803;
        v804 = cv804;
        v805 = cv805;
        v806 = cv806;
        v807 = cv807;
        v810 = cv810;
        v813 = cv813;
        v814 = cv814;
        v815 = cv815;
        
        continue;
        break;
        }
      case 'Bid_getBid0': {
        const v1017 = v929[1];
        const v1018 = v1017[stdlib.checkedBigNumberify('./token.rsh:201:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1036 = stdlib.add(v815, v1018);
        ;
        undefined;
        const v1051 = stdlib.lt(v810, v804);
        const v1058 = stdlib.ge(v1018, v835);
        const v1059 = v1051 ? v1058 : false;
        const v1060 = stdlib.ge(v1018, v757);
        const v1061 = v1059 ? v1060 : false;
        stdlib.assert(v1061, {
          at: './token.rsh:208:18:application',
          fs: ['at ./token.rsh:207:9:application call to [unknown function] (defined at: ./token.rsh:207:9:function exp)'],
          msg: null,
          who: 'Depositer'
          });
        const v1065 = stdlib.sub(v1036, v803);
        ;
        const v1066 = null;
        await txn4.getOutput('api', 'v1066', ctc3, v1066);
        const v1072 = stdlib.add(v804, stdlib.checkedBigNumberify('./token.rsh:157:33:decimal', stdlib.UInt_max, 60));
        const cv803 = v1018;
        const cv804 = v1072;
        const cv805 = v928;
        const cv806 = true;
        const cv807 = v930;
        const cv810 = v931;
        const cv813 = v813;
        const cv814 = v814;
        const cv815 = v1065;
        
        v803 = cv803;
        v804 = cv804;
        v805 = cv805;
        v806 = cv806;
        v807 = cv807;
        v810 = cv810;
        v813 = cv813;
        v814 = cv814;
        v815 = cv815;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0': {
        const v1102 = v929[1];
        const v1103 = v1102[stdlib.checkedBigNumberify('./token.rsh:226:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1121 = stdlib.add(v815, v1103);
        ;
        undefined;
        const v1162 = stdlib.ge(v810, v804);
        const v1163 = stdlib.lt(v803, v756);
        const v1164 = v1162 ? v1163 : false;
        const v1165 = stdlib.ge(v1103, v756);
        const v1166 = v1164 ? v1165 : false;
        stdlib.assert(v1166, {
          at: './token.rsh:234:18:application',
          fs: ['at ./token.rsh:233:9:application call to [unknown function] (defined at: ./token.rsh:233:9:function exp)'],
          msg: null,
          who: 'Depositer'
          });
        const v1170 = stdlib.sub(v1121, v803);
        ;
        const v1171 = null;
        await txn4.getOutput('api', 'v1171', ctc3, v1171);
        const cv803 = v1103;
        const cv804 = v804;
        const cv805 = v928;
        const cv806 = false;
        const cv807 = v930;
        const cv810 = v931;
        const cv813 = v813;
        const cv814 = v814;
        const cv815 = v1170;
        
        v803 = cv803;
        v804 = cv804;
        v805 = cv805;
        v806 = cv806;
        v807 = cv807;
        v810 = cv810;
        v813 = cv813;
        v814 = cv814;
        v815 = cv815;
        
        continue;
        break;
        }
      case 'Bid_touch0': {
        const v1187 = v929[1];
        ;
        ;
        undefined;
        const v1265 = null;
        await txn4.getOutput('api', 'v1265', ctc3, v1265);
        const cv803 = v803;
        const cv804 = v804;
        const cv805 = v805;
        const cv806 = true;
        const cv807 = v930;
        const cv810 = v931;
        const cv813 = v813;
        const cv814 = v814;
        const cv815 = v815;
        
        v803 = cv803;
        v804 = cv804;
        v805 = cv805;
        v806 = cv806;
        v807 = cv807;
        v810 = cv810;
        v813 = cv813;
        v814 = cv814;
        v815 = cv815;
        
        continue;
        break;
        }
      }
    
    }
  const v1272 = stdlib.add(v803, v758);
  const v1273 = stdlib.div(v803, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
  const v1274 = stdlib.mul(v1273, v759);
  const v1275 = stdlib.add(v803, v1274);
  const v1276 = stdlib.gt(v1272, v1275);
  const v1277 = v1276 ? v1272 : v1275;
  const v1279 = stdlib.div(v815, stdlib.checkedBigNumberify('./token.rsh:272:34:decimal', stdlib.UInt_max, 100));
  const v1280 = stdlib.mul(v755, v1279);
  const v1282 = stdlib.add(v1280, v1279);
  const v1283 = stdlib.sub(v815, v1282);
  const v1284 = stdlib.ge(v803, v756);
  if (v1284) {
    const v1289 = stdlib.sub(v814, v814);
    ;
    const v1293 = stdlib.sub(v815, v1283);
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 4,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1297, time: v1296, didSend: v669, from: v1295 } = txn4;
    ;
    const v1299 = stdlib.addressEq(v726, v1295);
    stdlib.assert(v1299, {
      at: './token.rsh:312:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Depositer'
      });
    if (v1284) {
      const v1303 = stdlib.sub(v1293, v1280);
      ;
      const v1307 = stdlib.sub(v1303, v1279);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  else {
    const v1352 = stdlib.add(v1283, v1280);
    const v1353 = stdlib.add(v1352, v1279);
    const v1357 = stdlib.sub(v815, v1353);
    ;
    const v1362 = stdlib.sub(v814, v814);
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 5,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1366, time: v1365, didSend: v669, from: v1364 } = txn4;
    ;
    const v1368 = stdlib.addressEq(v726, v1364);
    stdlib.assert(v1368, {
      at: './token.rsh:312:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Depositer'
      });
    if (v1284) {
      const v1372 = stdlib.sub(v1357, v1280);
      ;
      const v1376 = stdlib.sub(v1372, v1279);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  
  
  
  
  
  };
export async function Relay(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Relay expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Relay expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_close0: ctc4,
    Bid_getBid0: ctc5,
    Bid_getPurchase0: ctc5,
    Bid_touch0: ctc4
    });
  const ctc7 = stdlib.T_Bool;
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 4,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v719, v720, v721, v722], secs: v724, time: v723, didSend: v32, from: v718 } = txn1;
  ;
  const v726 = ctc.iam(v722);
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 13,
    funcNum: 1,
    out_tys: [ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc1],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v754, v755, v756, v757, v758, v759, v760, v761, v762, v763, v764, v765, v766], secs: v768, time: v767, didSend: v83, from: v753 } = txn2;
  const v769 = stdlib.tokenEq(v762, v763);
  const v770 = v769 ? false : true;
  stdlib.assert(v770, {
    at: './token.rsh:102:6:dot',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  ;
  ;
  ;
  stdlib.assert(v770, {
    at: './token.rsh:119:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v775 = stdlib.ge(v755, stdlib.checkedBigNumberify('./token.rsh:120:27:decimal', stdlib.UInt_max, 0));
  const v776 = stdlib.le(v755, stdlib.checkedBigNumberify('./token.rsh:120:48:decimal', stdlib.UInt_max, 99));
  const v777 = v775 ? v776 : false;
  stdlib.assert(v777, {
    at: './token.rsh:120:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v778 = stdlib.ge(v757, stdlib.checkedBigNumberify('./token.rsh:121:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v778, {
    at: './token.rsh:121:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v779 = stdlib.lt(v757, v756);
  stdlib.assert(v779, {
    at: './token.rsh:122:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v783 = stdlib.sub(stdlib.checkedBigNumberify('./token.rsh:118:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./token.rsh:125:12:decimal', stdlib.UInt_max, 20000));
  ;
  const v787 = stdlib.sub(v783, stdlib.checkedBigNumberify('./token.rsh:126:12:decimal', stdlib.UInt_max, 30000));
  ;
  const v791 = stdlib.sub(v787, stdlib.checkedBigNumberify('./token.rsh:127:12:decimal', stdlib.UInt_max, 50000));
  ;
  const v792 = v753;
  const txn3 = await (ctc.recv({
    didSend: false,
    evt_cnt: 0,
    funcNum: 2,
    out_tys: [],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [], secs: v795, time: v794, didSend: v112, from: v793 } = txn3;
  ;
  ;
  const v799 = stdlib.addressEq(v792, v793);
  stdlib.assert(v799, {
    at: './token.rsh:133:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Relay'
    });
  let v803 = stdlib.checkedBigNumberify('./token.rsh:169:24:decimal', stdlib.UInt_max, 0);
  let v804 = v766;
  let v805 = v753;
  let v806 = true;
  let v807 = v794;
  let v810 = v795;
  let v813 = v791;
  let v814 = stdlib.checkedBigNumberify('./token.rsh:133:15:decimal', stdlib.UInt_max, 1);
  let v815 = stdlib.checkedBigNumberify('./token.rsh:102:6:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    
    return v806;})()) {
    const v830 = stdlib.add(v803, v758);
    const v831 = stdlib.div(v803, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
    const v832 = stdlib.mul(v831, v759);
    const v833 = stdlib.add(v803, v832);
    const v834 = stdlib.gt(v830, v833);
    const v835 = v834 ? v830 : v833;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc6],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v929], secs: v931, time: v930, didSend: v551, from: v928 } = txn4;
    switch (v929[0]) {
      case 'Bid_close0': {
        const v932 = v929[1];
        ;
        ;
        undefined;
        const v954 = null;
        await txn4.getOutput('api', 'v954', ctc3, v954);
        const v961 = stdlib.lt(v810, v804);
        const cv803 = v803;
        const cv804 = v804;
        const cv805 = v805;
        const cv806 = v961;
        const cv807 = v930;
        const cv810 = v931;
        const cv813 = v813;
        const cv814 = v814;
        const cv815 = v815;
        
        v803 = cv803;
        v804 = cv804;
        v805 = cv805;
        v806 = cv806;
        v807 = cv807;
        v810 = cv810;
        v813 = cv813;
        v814 = cv814;
        v815 = cv815;
        
        continue;
        break;
        }
      case 'Bid_getBid0': {
        const v1017 = v929[1];
        const v1018 = v1017[stdlib.checkedBigNumberify('./token.rsh:201:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1036 = stdlib.add(v815, v1018);
        ;
        undefined;
        const v1051 = stdlib.lt(v810, v804);
        const v1058 = stdlib.ge(v1018, v835);
        const v1059 = v1051 ? v1058 : false;
        const v1060 = stdlib.ge(v1018, v757);
        const v1061 = v1059 ? v1060 : false;
        stdlib.assert(v1061, {
          at: './token.rsh:208:18:application',
          fs: ['at ./token.rsh:207:9:application call to [unknown function] (defined at: ./token.rsh:207:9:function exp)'],
          msg: null,
          who: 'Relay'
          });
        const v1065 = stdlib.sub(v1036, v803);
        ;
        const v1066 = null;
        await txn4.getOutput('api', 'v1066', ctc3, v1066);
        const v1072 = stdlib.add(v804, stdlib.checkedBigNumberify('./token.rsh:157:33:decimal', stdlib.UInt_max, 60));
        const cv803 = v1018;
        const cv804 = v1072;
        const cv805 = v928;
        const cv806 = true;
        const cv807 = v930;
        const cv810 = v931;
        const cv813 = v813;
        const cv814 = v814;
        const cv815 = v1065;
        
        v803 = cv803;
        v804 = cv804;
        v805 = cv805;
        v806 = cv806;
        v807 = cv807;
        v810 = cv810;
        v813 = cv813;
        v814 = cv814;
        v815 = cv815;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0': {
        const v1102 = v929[1];
        const v1103 = v1102[stdlib.checkedBigNumberify('./token.rsh:226:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1121 = stdlib.add(v815, v1103);
        ;
        undefined;
        const v1162 = stdlib.ge(v810, v804);
        const v1163 = stdlib.lt(v803, v756);
        const v1164 = v1162 ? v1163 : false;
        const v1165 = stdlib.ge(v1103, v756);
        const v1166 = v1164 ? v1165 : false;
        stdlib.assert(v1166, {
          at: './token.rsh:234:18:application',
          fs: ['at ./token.rsh:233:9:application call to [unknown function] (defined at: ./token.rsh:233:9:function exp)'],
          msg: null,
          who: 'Relay'
          });
        const v1170 = stdlib.sub(v1121, v803);
        ;
        const v1171 = null;
        await txn4.getOutput('api', 'v1171', ctc3, v1171);
        const cv803 = v1103;
        const cv804 = v804;
        const cv805 = v928;
        const cv806 = false;
        const cv807 = v930;
        const cv810 = v931;
        const cv813 = v813;
        const cv814 = v814;
        const cv815 = v1170;
        
        v803 = cv803;
        v804 = cv804;
        v805 = cv805;
        v806 = cv806;
        v807 = cv807;
        v810 = cv810;
        v813 = cv813;
        v814 = cv814;
        v815 = cv815;
        
        continue;
        break;
        }
      case 'Bid_touch0': {
        const v1187 = v929[1];
        ;
        ;
        undefined;
        const v1265 = null;
        await txn4.getOutput('api', 'v1265', ctc3, v1265);
        const cv803 = v803;
        const cv804 = v804;
        const cv805 = v805;
        const cv806 = true;
        const cv807 = v930;
        const cv810 = v931;
        const cv813 = v813;
        const cv814 = v814;
        const cv815 = v815;
        
        v803 = cv803;
        v804 = cv804;
        v805 = cv805;
        v806 = cv806;
        v807 = cv807;
        v810 = cv810;
        v813 = cv813;
        v814 = cv814;
        v815 = cv815;
        
        continue;
        break;
        }
      }
    
    }
  const v1272 = stdlib.add(v803, v758);
  const v1273 = stdlib.div(v803, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
  const v1274 = stdlib.mul(v1273, v759);
  const v1275 = stdlib.add(v803, v1274);
  const v1276 = stdlib.gt(v1272, v1275);
  const v1277 = v1276 ? v1272 : v1275;
  const v1279 = stdlib.div(v815, stdlib.checkedBigNumberify('./token.rsh:272:34:decimal', stdlib.UInt_max, 100));
  const v1280 = stdlib.mul(v755, v1279);
  const v1282 = stdlib.add(v1280, v1279);
  const v1283 = stdlib.sub(v815, v1282);
  const v1284 = stdlib.ge(v803, v756);
  if (v1284) {
    const v1289 = stdlib.sub(v814, v814);
    ;
    const v1293 = stdlib.sub(v815, v1283);
    ;
    const txn4 = await (ctc.sendrecv({
      args: [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1289, v1293],
      evt_cnt: 0,
      funcNum: 4,
      lct: v807,
      onlyIf: true,
      out_tys: [],
      pay: [stdlib.checkedBigNumberify('./token.rsh:decimal', stdlib.UInt_max, 0), []],
      sim_p: (async (txn4) => {
        const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
        
        const {data: [], secs: v1297, time: v1296, didSend: v669, from: v1295 } = txn4;
        
        sim_r.txns.push({
          amt: stdlib.checkedBigNumberify('./token.rsh:decimal', stdlib.UInt_max, 0),
          kind: 'to',
          tok: undefined
          });
        const v1299 = stdlib.addressEq(v726, v1295);
        stdlib.assert(v1299, {
          at: './token.rsh:312:7:dot',
          fs: [],
          msg: 'sender correct',
          who: 'Relay'
          });
        if (v1284) {
          const v1303 = stdlib.sub(v1293, v1280);
          sim_r.txns.push({
            amt: v1280,
            kind: 'from',
            to: v754,
            tok: v763
            });
          const v1307 = stdlib.sub(v1303, v1279);
          sim_r.txns.push({
            amt: v1279,
            kind: 'from',
            to: v720,
            tok: v763
            });
          sim_r.txns.push({
            amt: v813,
            kind: 'from',
            to: v720,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1289,
            kind: 'from',
            to: v720,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1307,
            kind: 'from',
            to: v720,
            tok: undefined
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v763
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v762
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          }
        else {
          sim_r.txns.push({
            amt: v813,
            kind: 'from',
            to: v720,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1289,
            kind: 'from',
            to: v720,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1293,
            kind: 'from',
            to: v720,
            tok: undefined
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v763
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v762
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          }
        return sim_r;
        }),
      soloSend: true,
      timeoutAt: undefined,
      tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc7, ctc1, ctc1],
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1297, time: v1296, didSend: v669, from: v1295 } = txn4;
    ;
    const v1299 = stdlib.addressEq(v726, v1295);
    stdlib.assert(v1299, {
      at: './token.rsh:312:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Relay'
      });
    if (v1284) {
      const v1303 = stdlib.sub(v1293, v1280);
      ;
      const v1307 = stdlib.sub(v1303, v1279);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  else {
    const v1352 = stdlib.add(v1283, v1280);
    const v1353 = stdlib.add(v1352, v1279);
    const v1357 = stdlib.sub(v815, v1353);
    ;
    const v1362 = stdlib.sub(v814, v814);
    ;
    const txn4 = await (ctc.sendrecv({
      args: [v720, v726, v753, v754, v755, v756, v757, v762, v763, v803, v804, v805, v813, v1277, v1279, v1280, v1284, v1357, v1362],
      evt_cnt: 0,
      funcNum: 5,
      lct: v807,
      onlyIf: true,
      out_tys: [],
      pay: [stdlib.checkedBigNumberify('./token.rsh:decimal', stdlib.UInt_max, 0), []],
      sim_p: (async (txn4) => {
        const sim_r = { txns: [], mapRefs: [], mapsPrev: [], mapsNext: [] };
        
        const {data: [], secs: v1366, time: v1365, didSend: v669, from: v1364 } = txn4;
        
        sim_r.txns.push({
          amt: stdlib.checkedBigNumberify('./token.rsh:decimal', stdlib.UInt_max, 0),
          kind: 'to',
          tok: undefined
          });
        const v1368 = stdlib.addressEq(v726, v1364);
        stdlib.assert(v1368, {
          at: './token.rsh:312:7:dot',
          fs: [],
          msg: 'sender correct',
          who: 'Relay'
          });
        if (v1284) {
          const v1372 = stdlib.sub(v1357, v1280);
          sim_r.txns.push({
            amt: v1280,
            kind: 'from',
            to: v754,
            tok: v763
            });
          const v1376 = stdlib.sub(v1372, v1279);
          sim_r.txns.push({
            amt: v1279,
            kind: 'from',
            to: v720,
            tok: v763
            });
          sim_r.txns.push({
            amt: v813,
            kind: 'from',
            to: v720,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1362,
            kind: 'from',
            to: v720,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1376,
            kind: 'from',
            to: v720,
            tok: undefined
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v763
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v762
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          }
        else {
          sim_r.txns.push({
            amt: v813,
            kind: 'from',
            to: v720,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1362,
            kind: 'from',
            to: v720,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1357,
            kind: 'from',
            to: v720,
            tok: undefined
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v763
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v762
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          }
        return sim_r;
        }),
      soloSend: true,
      timeoutAt: undefined,
      tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc7, ctc1, ctc1],
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1366, time: v1365, didSend: v669, from: v1364 } = txn4;
    ;
    const v1368 = stdlib.addressEq(v726, v1364);
    stdlib.assert(v1368, {
      at: './token.rsh:312:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Relay'
      });
    if (v1284) {
      const v1372 = stdlib.sub(v1357, v1280);
      ;
      const v1376 = stdlib.sub(v1372, v1279);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  
  
  
  
  
  };
const _ALGO = {
  appApproval: `#pragma version 5
txn RekeyTo
global ZeroAddress
==
assert
txn Lease
global ZeroAddress
==
assert
int 0
store 0
txn ApplicationID
bz alloc
byte base64()
app_global_get
dup
int 0
extract_uint64
store 1
int 8
extract_uint64
store 2
txn NumAppArgs
int 3
==
assert
txna ApplicationArgs 0
btoi
preamble:
// Handler 0
dup
int 0
==
bz l0_afterHandler0
pop
// check step
int 0
load 1
==
assert
// check time
txna ApplicationArgs 1
btoi
dup
int 0
==
swap
load 2
==
||
assert
byte base64()
pop
txna ApplicationArgs 2
dup
len
int 128
==
assert
dup
extract 0 32
store 255
dup
extract 32 32
store 254
dup
extract 64 32
store 253
dup
extract 96 32
store 252
pop
// "CheckPay"
// "./util.rsh:47:6:dot"
// "[]"
int 100000
dup
bz l1_checkTxnK
load 0
dup
int 1
+
store 0
swap
dig 1
gtxns Amount
==
assert
int pay
dig 1
gtxns TypeEnum
==
assert
int 0
dig 1
gtxns Fee
==
assert
global ZeroAddress
dig 1
gtxns Lease
==
assert
global ZeroAddress
dig 1
gtxns RekeyTo
==
assert
global CurrentApplicationAddress
dig 1
gtxns Receiver
==
assert
l1_checkTxnK:
pop
// "CheckPay"
// "./util.rsh:47:6:dot"
// "[at ./token.rsh:74:50:application call to \"construct\" (defined at: ./util.rsh:36:47:function exp)]"
load 252
store 251
load 255
load 254
concat
load 253
concat
load 252
concat
load 251
concat
int 1
bzero
dig 1
extract 0 127
app_global_put
byte base64(AQ==)
dig 1
extract 127 33
app_global_put
pop
int 1
store 1
global Round
store 2
txn OnCompletion
int NoOp
==
assert
b updateState
l0_afterHandler0:
// Handler 1
dup
int 1
==
bz l2_afterHandler1
pop
// check step
int 1
load 1
==
assert
// check time
txna ApplicationArgs 1
btoi
dup
int 0
==
swap
load 2
==
||
assert
int 1
bzero
app_global_get
byte base64(AQ==)
app_global_get
concat
dup
extract 0 32
store 255
dup
extract 32 32
store 254
dup
extract 64 32
store 253
dup
extract 96 32
store 252
dup
extract 128 32
store 251
pop
txna ApplicationArgs 2
dup
len
int 128
==
assert
dup
extract 0 32
store 250
dup
int 32
extract_uint64
store 249
dup
int 40
extract_uint64
store 248
dup
int 48
extract_uint64
store 247
dup
int 56
extract_uint64
store 246
dup
int 64
extract_uint64
store 245
dup
int 72
extract_uint64
store 244
dup
int 80
extract_uint64
store 243
dup
int 88
extract_uint64
store 242
dup
int 96
extract_uint64
store 241
dup
int 104
extract_uint64
store 240
dup
int 112
extract_uint64
store 239
dup
int 120
extract_uint64
store 238
pop
load 242
load 241
==
!
store 237
// Nothing
// "./token.rsh:102:6:dot"
// "[]"
load 237
assert
// Initializing token
int 100000
dup
bz l3_checkTxnK
load 0
dup
int 1
+
store 0
swap
dig 1
gtxns Amount
==
assert
int pay
dig 1
gtxns TypeEnum
==
assert
int 0
dig 1
gtxns Fee
==
assert
global ZeroAddress
dig 1
gtxns Lease
==
assert
global ZeroAddress
dig 1
gtxns RekeyTo
==
assert
global CurrentApplicationAddress
dig 1
gtxns Receiver
==
assert
l3_checkTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CurrentApplicationAddress
itxn_field AssetReceiver
load 242
itxn_field XferAsset
itxn_submit
int 0
l4_makeTxnK:
pop
// Initializing token
int 100000
dup
bz l5_checkTxnK
load 0
dup
int 1
+
store 0
swap
dig 1
gtxns Amount
==
assert
int pay
dig 1
gtxns TypeEnum
==
assert
int 0
dig 1
gtxns Fee
==
assert
global ZeroAddress
dig 1
gtxns Lease
==
assert
global ZeroAddress
dig 1
gtxns RekeyTo
==
assert
global CurrentApplicationAddress
dig 1
gtxns Receiver
==
assert
l5_checkTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CurrentApplicationAddress
itxn_field AssetReceiver
load 241
itxn_field XferAsset
itxn_submit
int 0
l6_makeTxnK:
pop
// "CheckPay"
// "./token.rsh:102:6:dot"
// "[]"
int 100000
dup
bz l7_checkTxnK
load 0
dup
int 1
+
store 0
swap
dig 1
gtxns Amount
==
assert
int pay
dig 1
gtxns TypeEnum
==
assert
int 0
dig 1
gtxns Fee
==
assert
global ZeroAddress
dig 1
gtxns Lease
==
assert
global ZeroAddress
dig 1
gtxns RekeyTo
==
assert
global CurrentApplicationAddress
dig 1
gtxns Receiver
==
assert
l7_checkTxnK:
pop
// Nothing
// "./token.rsh:119:10:application"
// "[]"
load 237
assert
// Nothing
// "./token.rsh:120:10:application"
// "[]"
load 249
int 0
>=
load 249
int 99
<=
&&
assert
// Nothing
// "./token.rsh:121:10:application"
// "[]"
load 247
int 0
>=
assert
// Nothing
// "./token.rsh:122:10:application"
// "[]"
load 247
load 248
<
assert
int 20000
dup
bz l8_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l8_makeTxnK:
pop
int 30000
dup
bz l9_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 253
itxn_field Receiver
itxn_submit
int 0
l9_makeTxnK:
pop
int 100000
int 20000
-
int 30000
-
int 50000
-
store 236
int 50000
dup
bz l10_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 252
itxn_field Receiver
itxn_submit
int 0
l10_makeTxnK:
pop
txn Sender
store 235
load 254
load 251
concat
txn Sender
concat
load 250
concat
load 249
itob
concat
load 248
itob
concat
load 247
itob
concat
load 246
itob
concat
load 245
itob
concat
load 242
itob
concat
load 241
itob
concat
load 238
itob
concat
load 236
itob
concat
load 235
concat
int 1
bzero
dig 1
extract 0 127
app_global_put
byte base64(AQ==)
dig 1
extract 127 105
app_global_put
pop
int 2
store 1
global Round
store 2
txn OnCompletion
int NoOp
==
assert
b updateState
l2_afterHandler1:
// Handler 2
dup
int 2
==
bz l11_afterHandler2
pop
// check step
int 2
load 1
==
assert
// check time
txna ApplicationArgs 1
btoi
dup
int 0
==
swap
load 2
==
||
assert
int 1
bzero
app_global_get
byte base64(AQ==)
app_global_get
concat
dup
extract 0 32
store 255
dup
extract 32 32
store 254
dup
extract 64 32
store 253
dup
extract 96 32
store 252
dup
int 128
extract_uint64
store 251
dup
int 136
extract_uint64
store 250
dup
int 144
extract_uint64
store 249
dup
int 152
extract_uint64
store 248
dup
int 160
extract_uint64
store 247
dup
int 168
extract_uint64
store 246
dup
int 176
extract_uint64
store 245
dup
int 184
extract_uint64
store 244
dup
int 192
extract_uint64
store 243
dup
extract 200 32
store 242
pop
txna ApplicationArgs 2
dup
len
int 0
==
assert
pop
// "CheckPay"
// "./token.rsh:133:6:dot"
// "[]"
// "CheckPay"
// "./token.rsh:133:6:dot"
// "[]"
int 1
dup
bz l12_checkTxnK
load 0
dup
int 1
+
store 0
swap
dig 1
gtxns AssetAmount
==
assert
load 246
dig 1
gtxns XferAsset
==
assert
int axfer
dig 1
gtxns TypeEnum
==
assert
int 0
dig 1
gtxns Fee
==
assert
global ZeroAddress
dig 1
gtxns Lease
==
assert
global ZeroAddress
dig 1
gtxns RekeyTo
==
assert
global CurrentApplicationAddress
dig 1
gtxns AssetReceiver
==
assert
l12_checkTxnK:
pop
// Just "sender correct"
// "./token.rsh:133:6:dot"
// "[]"
load 242
txn Sender
==
assert
load 255
load 254
concat
load 253
concat
load 252
concat
load 251
itob
concat
load 250
itob
concat
load 249
itob
concat
load 248
itob
concat
load 247
itob
concat
load 246
itob
concat
load 245
itob
concat
int 8
bzero
load 244
itob
concat
load 253
concat
int 1
itob // bool
substring 7 8
concat
global Round
itob
concat
global LatestTimestamp
itob
concat
load 243
itob
concat
byte base64(AAAAAAAAAAE=)
concat
int 8
bzero
concat
b loopBody3
l11_afterHandler2:
l13_afterHandler3:
// Handler 4
dup
int 4
==
bz l14_afterHandler4
pop
// check step
int 4
load 1
==
assert
// check time
txna ApplicationArgs 1
btoi
dup
int 0
==
swap
load 2
==
||
assert
int 1
bzero
app_global_get
byte base64(AQ==)
app_global_get
concat
byte base64(Ag==)
app_global_get
concat
dup
extract 0 32
store 255
dup
extract 32 32
store 254
dup
extract 64 32
store 253
dup
extract 96 32
store 252
dup
int 128
extract_uint64
store 251
dup
int 136
extract_uint64
store 250
dup
int 144
extract_uint64
store 249
dup
int 152
extract_uint64
store 248
dup
int 160
extract_uint64
store 247
dup
int 168
extract_uint64
store 246
dup
int 176
extract_uint64
store 245
dup
extract 184 32
store 244
dup
int 216
extract_uint64
store 243
dup
int 224
extract_uint64
store 242
dup
int 232
extract_uint64
store 241
dup
int 240
extract_uint64
store 240
dup
extract 248 1
btoi
store 239
dup
int 249
extract_uint64
store 238
dup
int 257
int 8
extract3
btoi
store 237
pop
txna ApplicationArgs 2
dup
len
int 0
==
assert
pop
// "CheckPay"
// "./token.rsh:312:7:dot"
// "[]"
// Just "sender correct"
// "./token.rsh:312:7:dot"
// "[]"
load 254
txn Sender
==
assert
load 239
bz l15_ifF
load 240
dup
bz l16_makeTxnK
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
load 252
itxn_field AssetReceiver
load 247
itxn_field XferAsset
itxn_submit
int 0
l16_makeTxnK:
pop
load 241
dup
bz l17_makeTxnK
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
load 255
itxn_field AssetReceiver
load 247
itxn_field XferAsset
itxn_submit
int 0
l17_makeTxnK:
pop
load 243
dup
bz l18_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l18_makeTxnK:
pop
load 238
dup
bz l19_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l19_makeTxnK:
pop
load 237
load 240
-
load 241
-
dup
bz l20_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l20_makeTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CreatorAddress
itxn_field AssetCloseTo
global CurrentApplicationAddress
itxn_field AssetReceiver
load 247
itxn_field XferAsset
itxn_submit
int 0
l21_makeTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CreatorAddress
itxn_field AssetCloseTo
global CurrentApplicationAddress
itxn_field AssetReceiver
load 248
itxn_field XferAsset
itxn_submit
int 0
l22_makeTxnK:
pop
int 0
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
global CreatorAddress
itxn_field CloseRemainderTo
global CurrentApplicationAddress
itxn_field Receiver
itxn_submit
int 0
l23_makeTxnK:
pop
txn OnCompletion
int DeleteApplication
==
assert
b updateState
l15_ifF:
load 243
dup
bz l24_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l24_makeTxnK:
pop
load 238
dup
bz l25_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l25_makeTxnK:
pop
load 237
dup
bz l26_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l26_makeTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CreatorAddress
itxn_field AssetCloseTo
global CurrentApplicationAddress
itxn_field AssetReceiver
load 247
itxn_field XferAsset
itxn_submit
int 0
l27_makeTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CreatorAddress
itxn_field AssetCloseTo
global CurrentApplicationAddress
itxn_field AssetReceiver
load 248
itxn_field XferAsset
itxn_submit
int 0
l28_makeTxnK:
pop
int 0
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
global CreatorAddress
itxn_field CloseRemainderTo
global CurrentApplicationAddress
itxn_field Receiver
itxn_submit
int 0
l29_makeTxnK:
pop
txn OnCompletion
int DeleteApplication
==
assert
b updateState
l14_afterHandler4:
// Handler 5
dup
int 5
==
bz l30_afterHandler5
pop
// check step
int 7
load 1
==
assert
// check time
txna ApplicationArgs 1
btoi
dup
int 0
==
swap
load 2
==
||
assert
int 1
bzero
app_global_get
byte base64(AQ==)
app_global_get
concat
byte base64(Ag==)
app_global_get
concat
dup
extract 0 32
store 255
dup
extract 32 32
store 254
dup
extract 64 32
store 253
dup
extract 96 32
store 252
dup
int 128
extract_uint64
store 251
dup
int 136
extract_uint64
store 250
dup
int 144
extract_uint64
store 249
dup
int 152
extract_uint64
store 248
dup
int 160
extract_uint64
store 247
dup
int 168
extract_uint64
store 246
dup
int 176
extract_uint64
store 245
dup
extract 184 32
store 244
dup
int 216
extract_uint64
store 243
dup
int 224
extract_uint64
store 242
dup
int 232
extract_uint64
store 241
dup
int 240
extract_uint64
store 240
dup
extract 248 1
btoi
store 239
dup
int 249
extract_uint64
store 238
dup
int 257
int 8
extract3
btoi
store 237
pop
txna ApplicationArgs 2
dup
len
int 0
==
assert
pop
// "CheckPay"
// "./token.rsh:312:7:dot"
// "[]"
// Just "sender correct"
// "./token.rsh:312:7:dot"
// "[]"
load 254
txn Sender
==
assert
load 239
bz l31_ifF
load 240
dup
bz l32_makeTxnK
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
load 252
itxn_field AssetReceiver
load 247
itxn_field XferAsset
itxn_submit
int 0
l32_makeTxnK:
pop
load 241
dup
bz l33_makeTxnK
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
load 255
itxn_field AssetReceiver
load 247
itxn_field XferAsset
itxn_submit
int 0
l33_makeTxnK:
pop
load 243
dup
bz l34_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l34_makeTxnK:
pop
load 237
dup
bz l35_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l35_makeTxnK:
pop
load 238
load 240
-
load 241
-
dup
bz l36_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l36_makeTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CreatorAddress
itxn_field AssetCloseTo
global CurrentApplicationAddress
itxn_field AssetReceiver
load 247
itxn_field XferAsset
itxn_submit
int 0
l37_makeTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CreatorAddress
itxn_field AssetCloseTo
global CurrentApplicationAddress
itxn_field AssetReceiver
load 248
itxn_field XferAsset
itxn_submit
int 0
l38_makeTxnK:
pop
int 0
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
global CreatorAddress
itxn_field CloseRemainderTo
global CurrentApplicationAddress
itxn_field Receiver
itxn_submit
int 0
l39_makeTxnK:
pop
txn OnCompletion
int DeleteApplication
==
assert
b updateState
l31_ifF:
load 243
dup
bz l40_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l40_makeTxnK:
pop
load 237
dup
bz l41_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l41_makeTxnK:
pop
load 238
dup
bz l42_makeTxnK
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
load 255
itxn_field Receiver
itxn_submit
int 0
l42_makeTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CreatorAddress
itxn_field AssetCloseTo
global CurrentApplicationAddress
itxn_field AssetReceiver
load 247
itxn_field XferAsset
itxn_submit
int 0
l43_makeTxnK:
pop
int 0
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
global CreatorAddress
itxn_field AssetCloseTo
global CurrentApplicationAddress
itxn_field AssetReceiver
load 248
itxn_field XferAsset
itxn_submit
int 0
l44_makeTxnK:
pop
int 0
itxn_begin
itxn_field Amount
int pay
itxn_field TypeEnum
global CreatorAddress
itxn_field CloseRemainderTo
global CurrentApplicationAddress
itxn_field Receiver
itxn_submit
int 0
l45_makeTxnK:
pop
txn OnCompletion
int DeleteApplication
==
assert
b updateState
l30_afterHandler5:
// Handler 6
dup
int 6
==
bz l46_afterHandler6
pop
// check step
int 10
load 1
==
assert
// check time
txna ApplicationArgs 1
btoi
dup
int 0
==
swap
load 2
==
||
assert
int 1
bzero
app_global_get
byte base64(AQ==)
app_global_get
concat
byte base64(Ag==)
app_global_get
concat
dup
extract 0 32
store 255
dup
extract 32 32
store 254
dup
extract 64 32
store 253
dup
extract 96 32
store 252
dup
int 128
extract_uint64
store 251
dup
int 136
extract_uint64
store 250
dup
int 144
extract_uint64
store 249
dup
int 152
extract_uint64
store 248
dup
int 160
extract_uint64
store 247
dup
int 168
extract_uint64
store 246
dup
int 176
extract_uint64
store 245
dup
int 184
extract_uint64
store 244
dup
int 192
extract_uint64
store 243
dup
extract 200 32
store 242
dup
int 232
extract_uint64
store 241
dup
int 240
extract_uint64
store 240
dup
int 248
extract_uint64
store 239
dup
int 256
int 8
extract3
btoi
store 238
dup
int 264
int 8
extract3
btoi
store 237
pop
txna ApplicationArgs 2
dup
len
int 9
==
assert
dup
store 236
pop
load 236
int 0
getbyte
int 0
==
bz l48_switchAfterBid_close0
// "CheckPay"
// "./token.rsh:166:19:dot"
// "[]"
// "CheckPay"
// "./token.rsh:166:19:dot"
// "[]"
byte base64(AAAAAAAAA7o=)
log // 8
byte base64()
load 255
load 254
concat
load 253
concat
load 252
concat
load 251
itob
concat
load 250
itob
concat
load 249
itob
concat
load 248
itob
concat
load 247
itob
concat
load 246
itob
concat
load 245
itob
concat
load 244
itob
load 243
itob
concat
load 242
concat
load 241
load 243
<
itob // bool
substring 7 8
concat
global Round
itob
concat
global LatestTimestamp
itob
concat
load 240
itob
concat
load 239
itob
concat
load 238
itob
concat
b loopBody3
l48_switchAfterBid_close0:
load 236
int 0
getbyte
int 1
==
bz l49_switchAfterBid_getBid0
load 236
extract 1 8
dup
store 235
btoi
store 234
// "CheckPay"
// "./token.rsh:166:19:dot"
// "[]"
// "CheckPay"
// "./token.rsh:166:19:dot"
// "[]"
load 234
dup
bz l50_checkTxnK
load 0
dup
int 1
+
store 0
swap
dig 1
gtxns AssetAmount
==
assert
load 245
dig 1
gtxns XferAsset
==
assert
int axfer
dig 1
gtxns TypeEnum
==
assert
int 0
dig 1
gtxns Fee
==
assert
global ZeroAddress
dig 1
gtxns Lease
==
assert
global ZeroAddress
dig 1
gtxns RekeyTo
==
assert
global CurrentApplicationAddress
dig 1
gtxns AssetReceiver
==
assert
l50_checkTxnK:
pop
// Nothing
// "./token.rsh:208:18:application"
// "[at ./token.rsh:207:9:application call to [unknown function] (defined at: ./token.rsh:207:9:function exp)]"
load 241
load 243
<
load 234
load 237
>=
&&
load 234
load 249
>=
&&
assert
load 244
dup
bz l51_makeTxnK
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
load 242
itxn_field AssetReceiver
load 245
itxn_field XferAsset
itxn_submit
int 0
l51_makeTxnK:
pop
byte base64(AAAAAAAABCo=)
log // 8
byte base64()
load 255
load 254
concat
load 253
concat
load 252
concat
load 251
itob
concat
load 250
itob
concat
load 249
itob
concat
load 248
itob
concat
load 247
itob
concat
load 246
itob
concat
load 245
itob
concat
load 234
itob
load 243
int 60
+
itob
concat
txn Sender
concat
int 1
itob // bool
substring 7 8
concat
global Round
itob
concat
global LatestTimestamp
itob
concat
load 240
itob
concat
load 239
itob
concat
load 238
load 234
+
load 244
-
itob
concat
b loopBody3
l49_switchAfterBid_getBid0:
load 236
int 0
getbyte
int 2
==
bz l52_switchAfterBid_getPurchase0
load 236
extract 1 8
dup
store 235
btoi
store 234
// "CheckPay"
// "./token.rsh:166:19:dot"
// "[]"
// "CheckPay"
// "./token.rsh:166:19:dot"
// "[]"
load 234
dup
bz l53_checkTxnK
load 0
dup
int 1
+
store 0
swap
dig 1
gtxns AssetAmount
==
assert
load 245
dig 1
gtxns XferAsset
==
assert
int axfer
dig 1
gtxns TypeEnum
==
assert
int 0
dig 1
gtxns Fee
==
assert
global ZeroAddress
dig 1
gtxns Lease
==
assert
global ZeroAddress
dig 1
gtxns RekeyTo
==
assert
global CurrentApplicationAddress
dig 1
gtxns AssetReceiver
==
assert
l53_checkTxnK:
pop
// Nothing
// "./token.rsh:234:18:application"
// "[at ./token.rsh:233:9:application call to [unknown function] (defined at: ./token.rsh:233:9:function exp)]"
load 241
load 243
>=
load 244
load 250
<
&&
load 234
load 250
>=
&&
assert
load 244
dup
bz l54_makeTxnK
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
load 242
itxn_field AssetReceiver
load 245
itxn_field XferAsset
itxn_submit
int 0
l54_makeTxnK:
pop
byte base64(AAAAAAAABJM=)
log // 8
byte base64()
load 255
load 254
concat
load 253
concat
load 252
concat
load 251
itob
concat
load 250
itob
concat
load 249
itob
concat
load 248
itob
concat
load 247
itob
concat
load 246
itob
concat
load 245
itob
concat
load 234
itob
load 243
itob
concat
txn Sender
concat
int 0
itob // bool
substring 7 8
concat
global Round
itob
concat
global LatestTimestamp
itob
concat
load 240
itob
concat
load 239
itob
concat
load 238
load 234
+
load 244
-
itob
concat
b loopBody3
l52_switchAfterBid_getPurchase0:
load 236
int 0
getbyte
int 3
==
bz l55_switchAfterBid_touch0
// "CheckPay"
// "./token.rsh:166:19:dot"
// "[]"
// "CheckPay"
// "./token.rsh:166:19:dot"
// "[]"
byte base64(AAAAAAAABPE=)
log // 8
byte base64()
load 255
load 254
concat
load 253
concat
load 252
concat
load 251
itob
concat
load 250
itob
concat
load 249
itob
concat
load 248
itob
concat
load 247
itob
concat
load 246
itob
concat
load 245
itob
concat
load 244
itob
load 243
itob
concat
load 242
concat
int 1
itob // bool
substring 7 8
concat
global Round
itob
concat
global LatestTimestamp
itob
concat
load 240
itob
concat
load 239
itob
concat
load 238
itob
concat
b loopBody3
l55_switchAfterBid_touch0:
l47_switchK:
l46_afterHandler6:
int 0
assert
loopBody3:
dup
int 0
extract_uint64
store 255
dup
int 8
extract_uint64
store 254
dup
extract 16 32
store 253
dup
extract 48 1
btoi
store 252
dup
int 49
extract_uint64
store 251
dup
int 57
extract_uint64
store 250
dup
int 65
extract_uint64
store 249
dup
int 73
extract_uint64
store 248
dup
int 81
extract_uint64
store 247
pop
dup
extract 0 32
store 246
dup
extract 32 32
store 245
dup
extract 64 32
store 244
dup
extract 96 32
store 243
dup
int 128
extract_uint64
store 242
dup
int 136
extract_uint64
store 241
dup
int 144
extract_uint64
store 240
dup
int 152
extract_uint64
store 239
dup
int 160
extract_uint64
store 238
dup
int 168
extract_uint64
store 237
dup
int 176
extract_uint64
store 236
pop
load 252
bz l56_ifF
load 255
load 239
+
store 235
load 255
dup
int 100
/
load 238
*
+
dup
store 234
load 235
dup
load 234
>
select
store 233
load 246
load 245
concat
load 244
concat
load 243
concat
load 242
itob
concat
load 241
itob
concat
load 240
itob
concat
load 239
itob
concat
load 238
itob
concat
load 237
itob
concat
load 236
itob
concat
load 255
itob
concat
load 254
itob
concat
load 253
concat
load 250
itob
concat
load 249
itob
concat
load 248
itob
concat
load 247
itob
concat
load 233
itob
concat
int 1
bzero
dig 1
extract 0 127
app_global_put
byte base64(AQ==)
dig 1
extract 127 127
app_global_put
byte base64(Ag==)
dig 1
extract 254 18
app_global_put
pop
int 10
store 1
global Round
store 2
txn OnCompletion
int NoOp
==
assert
b updateState
l56_ifF:
load 255
load 239
+
store 235
load 255
dup
int 100
/
load 238
*
+
dup
store 234
load 235
dup
load 234
>
select
store 233
load 247
int 100
/
store 232
load 242
load 232
*
store 231
load 247
load 231
load 232
+
-
store 230
load 255
load 241
>=
dup
store 229
bz l57_ifF
load 248
dup
-
store 228
load 248
dup
bz l58_makeTxnK
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
load 253
itxn_field AssetReceiver
load 237
itxn_field XferAsset
itxn_submit
int 0
l58_makeTxnK:
pop
load 247
load 230
-
store 227
load 230
dup
bz l59_makeTxnK
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
load 244
itxn_field AssetReceiver
load 236
itxn_field XferAsset
itxn_submit
int 0
l59_makeTxnK:
pop
load 246
load 245
concat
load 244
concat
load 243
concat
load 242
itob
concat
load 241
itob
concat
load 240
itob
concat
load 237
itob
concat
load 236
itob
concat
load 255
itob
concat
load 254
itob
concat
load 253
concat
load 249
itob
concat
load 233
itob
concat
load 232
itob
concat
load 231
itob
concat
load 229
itob // bool
substring 7 8
concat
load 228
itob
concat
load 227
itob
concat
int 1
bzero
dig 1
extract 0 127
app_global_put
byte base64(AQ==)
dig 1
extract 127 127
app_global_put
byte base64(Ag==)
dig 1
extract 254 11
app_global_put
pop
int 4
store 1
global Round
store 2
txn OnCompletion
int NoOp
==
assert
b updateState
l57_ifF:
load 230
load 231
+
load 232
+
store 228
load 247
load 228
-
store 227
load 228
dup
bz l60_makeTxnK
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
load 253
itxn_field AssetReceiver
load 236
itxn_field XferAsset
itxn_submit
int 0
l60_makeTxnK:
pop
load 248
dup
-
store 226
load 248
dup
bz l61_makeTxnK
itxn_begin
itxn_field AssetAmount
int axfer
itxn_field TypeEnum
load 244
itxn_field AssetReceiver
load 237
itxn_field XferAsset
itxn_submit
int 0
l61_makeTxnK:
pop
load 246
load 245
concat
load 244
concat
load 243
concat
load 242
itob
concat
load 241
itob
concat
load 240
itob
concat
load 237
itob
concat
load 236
itob
concat
load 255
itob
concat
load 254
itob
concat
load 253
concat
load 249
itob
concat
load 233
itob
concat
load 232
itob
concat
load 231
itob
concat
load 229
itob // bool
substring 7 8
concat
load 227
itob
concat
load 226
itob
concat
int 1
bzero
dig 1
extract 0 127
app_global_put
byte base64(AQ==)
dig 1
extract 127 127
app_global_put
byte base64(Ag==)
dig 1
extract 254 11
app_global_put
pop
int 7
store 1
global Round
store 2
txn OnCompletion
int NoOp
==
assert
updateState:
byte base64()
load 1
itob
load 2
itob
concat
app_global_put
checkSize:
load 0
dup
dup
int 1
+
global GroupSize
==
assert
txn GroupIndex
==
assert
int 1000
*
txn Fee
<=
assert
done:
int 1
return
alloc:
txn OnCompletion
int NoOp
==
assert
int 0
store 1
int 0
store 2
b updateState
`,
  appClear: `#pragma version 5
int 0
`,
  mapDataKeys: 0,
  mapDataSize: 0,
  stateKeys: 3,
  stateSize: 272,
  unsupported: [],
  version: 6
  };
const _ETH = {
  ABI: `[
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v719",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v720",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v721",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v722",
                "type": "address"
              }
            ],
            "internalType": "struct T5",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T6",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "stateMutability": "payable",
    "type": "constructor"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "msg",
        "type": "uint256"
      }
    ],
    "name": "ReachError",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v719",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v720",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v721",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v722",
                "type": "address"
              }
            ],
            "internalType": "struct T5",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T6",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e0",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v754",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v755",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v756",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v757",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v758",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v759",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v760",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v761",
                "type": "uint256"
              },
              {
                "internalType": "address payable",
                "name": "v762",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v763",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v764",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v765",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v766",
                "type": "uint256"
              }
            ],
            "internalType": "struct T7",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T8",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e1",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "indexed": false,
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e2",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "indexed": false,
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e4",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "indexed": false,
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e5",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T16",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_close0",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T15",
                    "name": "_Bid_getBid0",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T15",
                    "name": "_Bid_getPurchase0",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_touch0",
                    "type": "tuple"
                  }
                ],
                "internalType": "struct T16",
                "name": "v929",
                "type": "tuple"
              }
            ],
            "internalType": "struct T17",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T18",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e6",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v1066",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1066",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v1171",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1171",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v1265",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1265",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v954",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v954",
    "type": "event"
  },
  {
    "stateMutability": "payable",
    "type": "fallback"
  },
  {
    "inputs": [],
    "name": "Auction_bids",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_closed",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_closes",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_currentPrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_endCTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_endSecs",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_highestBidder",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_lastCTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_minBid",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_reservePrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_royalties",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_startPrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_token",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_tokenP",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bool",
        "name": "_a0",
        "type": "bool"
      }
    ],
    "name": "Bid_close",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_a0",
        "type": "uint256"
      }
    ],
    "name": "Bid_getBid",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_a0",
        "type": "uint256"
      }
    ],
    "name": "Bid_getPurchase",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bool",
        "name": "_a0",
        "type": "bool"
      }
    ],
    "name": "Bid_touch",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCreationTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCurrentState",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCurrentTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v754",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v755",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v756",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v757",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v758",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v759",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v760",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v761",
                "type": "uint256"
              },
              {
                "internalType": "address payable",
                "name": "v762",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v763",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v764",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v765",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v766",
                "type": "uint256"
              }
            ],
            "internalType": "struct T7",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T8",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m1",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m2",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m4",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m5",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T16",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_close0",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T15",
                    "name": "_Bid_getBid0",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T15",
                    "name": "_Bid_getPurchase0",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_touch0",
                    "type": "tuple"
                  }
                ],
                "internalType": "struct T16",
                "name": "v929",
                "type": "tuple"
              }
            ],
            "internalType": "struct T17",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T18",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m6",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "stateMutability": "payable",
    "type": "receive"
  }
]`,
  Bytecode: `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`,
  BytecodeLen: 27448,
  Which: `oD`,
  version: 5,
  views: {
    Auction: {
      bids: `Auction_bids`,
      closed: `Auction_closed`,
      closes: `Auction_closes`,
      currentPrice: `Auction_currentPrice`,
      endCTime: `Auction_endCTime`,
      endSecs: `Auction_endSecs`,
      highestBidder: `Auction_highestBidder`,
      lastCTime: `Auction_lastCTime`,
      minBid: `Auction_minBid`,
      owner: `Auction_owner`,
      reservePrice: `Auction_reservePrice`,
      royalties: `Auction_royalties`,
      startPrice: `Auction_startPrice`,
      token: `Auction_token`,
      tokenP: `Auction_tokenP`
      }
    }
  };
export const _Connectors = {
  ALGO: _ALGO,
  ETH: _ETH
  };
export const _Participants = {
  "Auctioneer": Auctioneer,
  "Bid_close": Bid_close,
  "Bid_getBid": Bid_getBid,
  "Bid_getPurchase": Bid_getPurchase,
  "Bid_touch": Bid_touch,
  "Constructor": Constructor,
  "Depositer": Depositer,
  "Relay": Relay
  };
export const _APIs = {
  Bid: {
    close: Bid_close,
    getBid: Bid_getBid,
    getPurchase: Bid_getPurchase,
    touch: Bid_touch
    }
  };
